var _path, _polyline, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.85,359.34c-2-2.1-4.95-2.9-7.67-3.9A41.21,41.21,0,0,1,98.3,292.26l-.41-2.11c-.93-9.86-12.83-16.92-21.93-13S63.78,294.52,70.28,302c-10.67.88-17.73,13-16.22,23.65s9.26,19.3,17.9,25.63a84.74,84.74,0,0,0,49.21,16.26,6.82,6.82,0,0,0,3.5-.63C127.17,365.44,126.85,361.45,124.85,359.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.2,316.21c2.45-4,2.8-9.35.31-13.31s-7.95-5.95-12.2-4a8.93,8.93,0,0,0-15.16-9.45c-2.84,4.39-1.34,10.28,1.1,14.91s5.79,9,6.59,14.13-1.2,10.68-4.36,15-7.37,7.7-11.54,11l-.79.76a28.66,28.66,0,0,0,23-2c3.92-2.17,7.55-5.76,7.81-10.23.14-2.5-.79-5-.41-7.48C417.06,322,420.26,319.36,422.2,316.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.15,479.69c-3.89-.48-7.79-2.18-10.08-5.36-1.46-2-2.17-4.52-3.44-6.68s-3.48-4.11-6-3.87c-3.86.38-6.47,5.72-10.24,4.78-2.26-.57-3.34-3.23-3.35-5.56s.66-4.66.37-7c-.81-6.51-9.17-9.71-15.41-7.67s-15.7,9.55-19.77,14.7c4.28,7.11,13.05,9.87,21.09,11.89q20.25,5.07,40.85,8.61c3.22.55,6.51,1.08,9.73.57s6.43-2.22,7.92-5.12C215,479.59,211,480.18,207.15,479.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362,429.55c-1-5.56-6.54-10.46-12-9.18,4.56-3.76,4.59-11.32,1-16s-9.88-6.71-15.79-6.53-11.58,2.25-17.06,4.45c2.69-3.42-1.25-8.76-5.59-9s-8.23,2.47-11.76,5-7.59,5.16-11.89,4.49l4,1.62c9.65,1.46,19.38,3.71,27.73,8.75s15.24,13.26,16.68,22.91-3.64,20.45-12.79,23.83A38.81,38.81,0,0,0,357,445.21C360.44,440.75,363,435.1,362,429.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.93,285.35a84.65,84.65,0,0,1-.26-9.31,84.77,84.77,0,0,1,.26-9.32,81.89,81.89,0,0,1,.26,9.32A81.78,81.78,0,0,1,44.93,285.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.56,276a90.5,90.5,0,0,1-9.63.26,90.39,90.39,0,0,1-9.62-.26,87.31,87.31,0,0,1,9.62-.26A87.43,87.43,0,0,1,54.56,276Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.42,381.09a81.78,81.78,0,0,1-.26-9.31,81.89,81.89,0,0,1,.26-9.32,84.77,84.77,0,0,1,.26,9.32A84.65,84.65,0,0,1,416.42,381.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.05,371.77a86,86,0,0,1-9.63.27,85.83,85.83,0,0,1-9.63-.27,90.5,90.5,0,0,1,9.63-.26A90.66,90.66,0,0,1,426.05,371.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.91,61.45a81.89,81.89,0,0,1-.26-9.32,81.78,81.78,0,0,1,.26-9.31,84.65,84.65,0,0,1,.26,9.31A84.77,84.77,0,0,1,359.91,61.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.54,52.13a87.43,87.43,0,0,1-9.63.26,87.43,87.43,0,0,1-9.63-.26,90.5,90.5,0,0,1,9.63-.26A90.5,90.5,0,0,1,369.54,52.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.65,
    cy: 197.85,
    r: 5.69,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.76,440.24a5.7,5.7,0,1,1-5.7-5.69A5.69,5.69,0,0,1,282.76,440.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.72,332.68A5.69,5.69,0,1,1,330,327,5.69,5.69,0,0,1,335.72,332.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.61,49.26a5.69,5.69,0,1,1-5.69-5.69A5.69,5.69,0,0,1,166.61,49.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190.73,
    cy: 385.97,
    r: 2.85,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.91,371.77a2.85,2.85,0,1,1-2.85-2.84A2.84,2.84,0,0,1,124.91,371.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.07,55a2.85,2.85,0,1,1-2.85-2.85A2.86,2.86,0,0,1,195.07,55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.43,208.94a2.85,2.85,0,1,1-2.85-2.85A2.85,2.85,0,0,1,320.43,208.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.13,46.5s-6.34,3.27,2.54,16.55,14.7,19.68,14.7,19.68,1.67,3.13-1,4-8.89.59-9.72,4.11,2.07,6.66,7.58,9S78.56,107.5,79.64,108s2.21,1.89.46,2.76S64.85,114.67,66.68,121s18.21,10.18,20,10.64,2.28,1.13,2.25,2.08-4.67,1.55-8.47,2.57-8,2.88-6.68,6.44,11.57,10.16,34.42,9.7l10.57-.9,4.68-9.58c8.77-21.1,6.35-33,3.53-35.59s-6.09.7-8.43,3.87-4.59,7.27-5.49,7-1.34-1-1.11-2.86,2.61-18.48-2.61-22.49-13,7.45-14.43,8.77-2.33-.29-2.4-1.45S91.68,84.92,91.56,79,89.71,69.17,86,68.64,80.38,74,78.62,76.19s-4.07-.48-4.07-.48-3.84-7.76-13-20.87S47,46.58,47,46.58",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.6,153.93c-6.66-9.65-18.2-27-28.2-41.87s-19-28.28-25.65-38L57.91,62.62c-.92-1.34-1.63-2.39-2.13-3.11-.23-.36-.42-.63-.55-.82s-.17-.29-.17-.29l.2.27.58.8L58,62.55c1.89,2.68,4.59,6.58,7.92,11.41C72.6,83.61,81.69,97,91.68,111.88s21.51,32.23,28.12,41.92",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.26,91.5a3.41,3.41,0,0,1,.76.12c.48.09,1.18.25,2,.46,1.71.4,4.07,1,6.65,1.76l6.62,1.91,2,.57a2.61,2.61,0,0,1,.73.24,3.57,3.57,0,0,1-.76-.12c-.48-.09-1.18-.25-2-.46-1.71-.43-4.06-1.08-6.65-1.82L65,92.3l-2-.56A3.64,3.64,0,0,1,62.26,91.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7,95.8c-.08,0,1-4.93,2.4-11s2.64-10.92,2.72-10.9-1,4.94-2.4,11S81.79,95.82,81.7,95.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,119.3a3,3,0,0,1,.35-.7l1-1.86c.88-1.57,2.09-3.74,3.34-6.18s2.3-4.69,3-6.32l.89-1.94a3.53,3.53,0,0,1,.36-.69,3.22,3.22,0,0,1-.24.74c-.18.48-.45,1.15-.8,2-.69,1.66-1.72,3.93-3,6.38s-2.49,4.61-3.42,6.15c-.47.77-.86,1.38-1.14,1.8A4,4,0,0,1,96,119.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.58,119.28a2.85,2.85,0,0,1,.72-.07l2-.08c1.67,0,4-.09,6.5-.12s4.83,0,6.49,0l2,0a3.13,3.13,0,0,1,.72,0,3,3,0,0,1-.72.07l-2,.08c-1.67.05-4,.1-6.5.13s-4.83,0-6.49,0l-2,0A3.42,3.42,0,0,1,77.58,119.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.58,141.63a5,5,0,0,1,.92-.08l2.52-.11c2.13-.08,5.07-.16,8.32-.23s6.19-.11,8.32-.13h2.53a6.12,6.12,0,0,1,.92,0,3.65,3.65,0,0,1-.92.09l-2.52.1c-2.13.08-5.07.16-8.32.23s-6.19.12-8.33.13H88.5A5.2,5.2,0,0,1,87.58,141.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.55,141a5.74,5.74,0,0,1,.42-.9l1.24-2.4c1.05-2,2.48-4.83,4-8s2.78-6,3.69-8.1l1.09-2.48a6.17,6.17,0,0,1,.43-.89,5.83,5.83,0,0,1-.31.94c-.23.6-.56,1.46-1,2.52-.86,2.11-2.11,5-3.62,8.16s-3,5.94-4.06,7.94c-.56,1-1,1.8-1.34,2.35A5.63,5.63,0,0,1,110.55,141Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.5,237c-11.27-9.83-12.34-25.93-10.32-40.09.33-2.37.34-4.9,1.7-6.86s4.14-3.1,6.15-1.87c1.67,1,2.22,3.15,3,5a14,14,0,0,0,5,5.91c1.43.95,3.25,1.63,4.83,1,2.17-.9,2.71-3.7,2.95-6.07q.68-6.6,1.34-13.2a22,22,0,0,1,1.47-6.93,7.35,7.35,0,0,1,5.13-4.45c2.31-.39,4.95,1.21,5.17,3.57a20.83,20.83,0,0,1-.25,2.94,2.49,2.49,0,0,0,1.2,2.49,2.85,2.85,0,0,0,2.71-.8,31.48,31.48,0,0,0,6.55-7.9,43.74,43.74,0,0,1,6.2-8.2c2.49-2.36,5.77-4.09,9.17-3.92s6.77,2.65,7.27,6-1.81,6.59-4.21,9.05a52.84,52.84,0,0,1-12.09,9.27,4.42,4.42,0,0,0-2.05,1.78c-.68,1.52.64,3.24,2.14,3.92,1.69.78,3.62.8,5.44,1.22s3.72,1.44,4.23,3.25c.71,2.52-1.58,4.83-3.75,6.27a45.27,45.27,0,0,1-14.18,6.27,15.33,15.33,0,0,0-5.22,1.88c-1.53,1.06-2.61,3.09-1.94,4.85s2.78,2.52,4.64,2.38a33.47,33.47,0,0,0,5.39-1.42c3.37-.88,7.53-.2,9.31,2.82a7.53,7.53,0,0,1,.08,6.69,17.37,17.37,0,0,1-4.2,5.45,45.76,45.76,0,0,1-20.84,11.52c-7.8,1.8-14.85,1.75-22-1.79",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.13,228.47A211.38,211.38,0,0,1,406,206.61l3.14-5.58c1-1.83,2.06-3.64,3.17-5.36a107.59,107.59,0,0,1,7-9.48c2.36-2.9,4.7-5.58,6.91-8.06s4.33-4.75,6.34-6.74a85.09,85.09,0,0,1,10.17-8.68c1.28-.92,2.3-1.61,3-2.06l.79-.52.28-.16a1.31,1.31,0,0,1-.25.2l-.77.55c-.68.48-1.68,1.19-2.94,2.13a90.07,90.07,0,0,0-10.06,8.76c-2,2-4.08,4.28-6.28,6.76s-4.53,5.17-6.87,8.08a106.42,106.42,0,0,0-6.91,9.46c-1.1,1.7-2.12,3.5-3.15,5.34l-3.14,5.58a219.26,219.26,0,0,0-10.85,21.8",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.41,195.67a4.92,4.92,0,0,1-.12-1c-.06-.67-.1-1.63-.14-2.83-.08-2.38-.08-5.68-.07-9.31s0-6.93-.14-9.31c-.06-1.19-.11-2.15-.16-2.81a4.85,4.85,0,0,1,0-1,4.5,4.5,0,0,1,.19,1c.1.66.2,1.62.29,2.81.2,2.38.3,5.68.28,9.33s0,6.83-.06,9.31v2.82A5.34,5.34,0,0,1,412.41,195.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.35,193.27a6.79,6.79,0,0,1-1.22,0c-.79,0-1.93,0-3.33,0-2.81,0-6.69.14-11,.48s-8.14.82-10.92,1.25c-1.39.2-2.51.4-3.29.53a6.63,6.63,0,0,1-1.21.16,5.86,5.86,0,0,1,1.18-.33c.77-.18,1.89-.43,3.28-.67,2.77-.51,6.64-1,10.93-1.38a107.27,107.27,0,0,1,11-.35c1.41,0,2.55.1,3.34.17A6,6,0,0,1,443.35,193.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.56,228a1.79,1.79,0,0,1-.17-.39c-.1-.31-.24-.69-.4-1.15-.34-1-.8-2.47-1.34-4.29-1.09-3.63-2.44-8.69-3.85-14.3s-2.71-10.69-3.72-14.34c-.49-1.77-.9-3.23-1.21-4.32-.13-.47-.23-.86-.32-1.18a2,2,0,0,1-.09-.42,1.34,1.34,0,0,1,.17.4l.4,1.15c.35,1,.81,2.47,1.35,4.28,1.09,3.64,2.43,8.7,3.84,14.31s2.71,10.68,3.72,14.34c.5,1.77.91,3.23,1.21,4.32l.33,1.17A1.23,1.23,0,0,1,395.56,228Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.27,219.31a2.52,2.52,0,0,1-.42.12l-1.21.26-4.47.94c-3.77.79-9,1.94-14.71,3.21s-10.95,2.39-14.74,3.1c-1.9.35-3.43.63-4.5.79l-1.23.19a1.17,1.17,0,0,1-.43,0l.42-.12,1.21-.26,4.47-.94c3.77-.79,9-1.94,14.71-3.22s10.95-2.38,14.74-3.09c1.9-.36,3.43-.63,4.5-.79l1.23-.19A1.17,1.17,0,0,1,437.27,219.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.63,68c1.81-10.42,6.78-25.65,12.73-34.39S331.48,18,342,16.5,364,20,368.7,29.43c2.53,5.07,3,10.91,4.84,16.26s5.88,10.72,11.53,11.15c5,.39,9.83-3.22,14.75-2.26,6.42,1.25,8.89,9.15,8.93,15.68s-.9,13.79,3.12,18.94c3.28,4.22,8.91,5.67,13.44,8.5,9.81,6.12,14,18.75,13,30.27s-6.3,22.18-11.93,32.27a252.86,252.86,0,0,0-19-47.88c-4.55-8.72-12.86-16.13-20.21-22.66-11.29-10-36.06-14.81-51.05-16.65s-17.63-2.24-32.46-5",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--back-screens--inject-27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.71,80.3c-37.07,2.69-77.55,7.6-107.23,19l9.38,63.43s57.52-20.59,104.33-19.16Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.71,80.3c-37.07,2.69-77.55,7.6-107.23,19l9.38,63.43s57.52-20.59,104.33-19.16Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M201,135.2l-.36.06-1.05.15-4,.5c-1.76.21-3.91.47-6.4.83s-5.33.72-8.45,1.24c-12.51,1.93-29.73,5.12-48.43,10-6.5,1.68-12.77,3.41-18.5,5.21l-.29.08,0-.29c-2-14.54-3.94-27.08-5.43-36-.76-4.42-1.37-8-1.79-10.41-.21-1.19-.37-2.12-.49-2.78,0-.3-.08-.54-.11-.72a.8.8,0,0,1,0-.25,1,1,0,0,1,.07.24c0,.18.09.42.16.71.13.66.32,1.58.57,2.77.48,2.41,1.15,5.94,1.93,10.38,1.58,8.88,3.58,21.42,5.62,36l-.33-.2c5.75-1.82,12-3.56,18.53-5.24a472.25,472.25,0,0,1,48.5-9.82c3.13-.49,6-.82,8.47-1.15s4.65-.57,6.41-.75l4.06-.41,1.06-.09A1.39,1.39,0,0,1,201,135.2Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.3,119.78s-.14-.44-.43-1.27a13.31,13.31,0,0,0-1.91-3.27,16.61,16.61,0,0,0-4.5-3.95c-.48-.32-1.05-.56-1.6-.85a14.32,14.32,0,0,0-1.81-.65,9.9,9.9,0,0,0-4.13-.4,8.6,8.6,0,0,0-4.2,1.65,14.23,14.23,0,0,0-3.36,3.65c-2,2.89-3.21,6.41-4.71,10.06a12.49,12.49,0,0,1-3.49,5,6.55,6.55,0,0,1-2.89,1.39,5.87,5.87,0,0,1-3.26-.38c-4.22-1.67-6.1-6.54-10.37-8a8.37,8.37,0,0,0-6.33.52,8.1,8.1,0,0,0-2.51,1.94,13,13,0,0,0-1.67,2.68c-.95,1.88-1.67,4-3.28,5.45a4.88,4.88,0,0,1-2.88,1.29,5.75,5.75,0,0,1-3-.64,10.87,10.87,0,0,1-4.14-4.07,36,36,0,0,1-2.19-5,23.53,23.53,0,0,0-2.17-4.51,9,9,0,0,0-3.31-3.08,8.6,8.6,0,0,0-7.6-.22,12.85,12.85,0,0,0-4.83,3.48,9.37,9.37,0,0,0-1.81,3.31c-.26.83-.29,1.3-.33,1.29a5.66,5.66,0,0,1,.23-1.32,9,9,0,0,1,1.75-3.41,13,13,0,0,1,4.87-3.62,8.88,8.88,0,0,1,7.89.17,9.34,9.34,0,0,1,3.48,3.18,23.72,23.72,0,0,1,2.23,4.58,36.14,36.14,0,0,0,2.19,4.91,10.33,10.33,0,0,0,4,3.88,5.27,5.27,0,0,0,2.75.59,4.45,4.45,0,0,0,2.59-1.18c1.48-1.35,2.2-3.39,3.15-5.3a13.45,13.45,0,0,1,1.74-2.8,8.58,8.58,0,0,1,2.67-2.06,8.87,8.87,0,0,1,6.73-.55c2.27.75,3.9,2.5,5.41,4.08a15.13,15.13,0,0,0,5,4,5.37,5.37,0,0,0,3,.35,6.14,6.14,0,0,0,2.67-1.28,12.18,12.18,0,0,0,3.36-4.8c1.49-3.61,2.8-7.18,4.8-10.11a14.17,14.17,0,0,1,3.48-3.74,9.08,9.08,0,0,1,4.39-1.69,10.3,10.3,0,0,1,4.26.45,14.44,14.44,0,0,1,1.85.69,17.24,17.24,0,0,1,6.13,5,12.83,12.83,0,0,1,1.85,3.37,9.29,9.29,0,0,1,.26,1A2.12,2.12,0,0,1,202.3,119.78Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.05,111.45c0,.14-.46.35-1.08.47s-1.15.1-1.17,0,.45-.35,1.07-.47S104,111.31,104.05,111.45Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.69,123c.06.14-.3.43-.81.67s-1,.32-1,.19.31-.42.82-.66S105.63,122.9,105.69,123Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.74,135.69c0,.14-.33.39-.84.57s-1,.21-1,.08.33-.39.84-.57S107.69,135.56,107.74,135.69Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.2,148.13c0,.14-.39.4-1,.57s-1.06.22-1.1.08.38-.39.94-.57S110.15,148,110.2,148.13Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.11,88.36a5.19,5.19,0,0,1,1.21-.28c.8-.13,2-.31,3.45-.52,3-.42,7.21-1,12.26-1.59l.24,0,0,.24c.39,4.26.85,9.16,1.33,14.36l0,.22,0,.25-.25,0-16.57,2-.23,0,0-.22c-.46-4.35-.85-8-1.13-10.59-.12-1.22-.21-2.19-.29-2.93a8.4,8.4,0,0,1-.06-1,9,9,0,0,1,.18,1.06c.11.74.24,1.73.41,3,.33,2.58.78,6.16,1.33,10.46l-.25-.2,16.57-2.11-.23.28,0-.21c-.46-5.2-.89-10.11-1.27-14.37l.26.21Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.51,90.88c0,.16-2.85.15-6.33.53s-6.27,1-6.31.81a30.76,30.76,0,0,1,12.64-1.34Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.69,94.6c0,.15-2.66.25-5.91.57s-5.89.72-5.92.57a23.18,23.18,0,0,1,5.87-1.09A22.82,22.82,0,0,1,195.69,94.6Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.72,97.84a10.94,10.94,0,0,1-3.38.69,11.67,11.67,0,0,1-3.43.18,11.28,11.28,0,0,1,3.37-.69A11.74,11.74,0,0,1,191.72,97.84Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.43,99c-36.3-11.06-66.93-20.51-108-20.25l-6.28,64.63c42.71,3.78,57,6.58,96.42,20.85Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384.43,99c-36.3-11.06-66.93-20.51-108-20.25l-6.28,64.63c42.71,3.78,57,6.58,96.42,20.85Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M302.25,110.07l1.6-13.71a16.05,16.05,0,0,0-11.19,3.1A16.82,16.82,0,0,0,285.78,113a19.67,19.67,0,0,0,.05,2,.07.07,0,0,0,0,0h0l16-1.8Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.8,107.83A15.51,15.51,0,0,0,307.39,97l-.48-.1-.31-.07-.94-.14h-.08L304,110.34l-.38,3.22,15.12,5.52h0a17.32,17.32,0,0,0,.78-3.51A18.87,18.87,0,0,0,318.8,107.83Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M318.8,107.83A15.51,15.51,0,0,0,307.39,97l-.48-.1-.31-.07-.94-.14h-.08L304,110.34l-.38,3.22,15.12,5.52h0a17.32,17.32,0,0,0,.78-3.51A18.87,18.87,0,0,0,318.8,107.83Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M302.48,115.1l-16,1.8c.67,7.76,6.33,14.19,13.93,15.13s14.73-4,17.23-11.4l-15.12-5.52",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.4,111.28a8.62,8.62,0,0,1-1.41-.57c-.89-.41-2.19-1-3.81-1.65a116.38,116.38,0,0,0-12.88-4.52,117.56,117.56,0,0,0-13.34-3c-1.72-.28-3.13-.48-4.1-.61a7.76,7.76,0,0,1-1.5-.26,9.78,9.78,0,0,1,1.53.06c1,.07,2.39.22,4.13.45a96.28,96.28,0,0,1,26.31,7.5c1.6.72,2.88,1.34,3.75,1.8A9,9,0,0,1,370.4,111.28Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.3,118a9.49,9.49,0,0,1-1.41-.58c-.89-.4-2.19-1-3.81-1.64a113.36,113.36,0,0,0-26.22-7.48c-1.72-.28-3.13-.48-4.1-.61a10.4,10.4,0,0,1-1.5-.26,7.39,7.39,0,0,1,1.53.06c1,.06,2.39.21,4.13.44a96.62,96.62,0,0,1,13.42,2.82,98.25,98.25,0,0,1,12.89,4.69c1.6.72,2.88,1.34,3.75,1.8A7.43,7.43,0,0,1,369.3,118Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.2,124.77a8.62,8.62,0,0,1-1.41-.57c-.89-.4-2.19-1-3.81-1.65A118.49,118.49,0,0,0,350.1,118a119.79,119.79,0,0,0-13.34-3c-1.72-.27-3.12-.48-4.1-.61a7.76,7.76,0,0,1-1.5-.26,9.78,9.78,0,0,1,1.53.06c1,.07,2.39.22,4.13.45a96.62,96.62,0,0,1,13.42,2.82,95.42,95.42,0,0,1,12.89,4.69c1.6.72,2.88,1.34,3.75,1.8A7.91,7.91,0,0,1,368.2,124.77Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366,131.52a9.82,9.82,0,0,1-1.37-.57c-.86-.41-2.12-1-3.68-1.64a107.88,107.88,0,0,0-25.44-7.49c-1.68-.28-3-.48-4-.61a7.46,7.46,0,0,1-1.46-.26,8,8,0,0,1,1.49.06c.95.06,2.32.21,4,.45a91.3,91.3,0,0,1,13.05,2.82A93.27,93.27,0,0,1,361.1,129c1.55.72,2.79,1.34,3.62,1.8A7.8,7.8,0,0,1,366,131.52Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.22,136.9a7.64,7.64,0,0,1-1.23-.49l-3.31-1.47a80.57,80.57,0,0,0-22.82-6.51l-3.59-.5a8.08,8.08,0,0,1-1.31-.23,5.66,5.66,0,0,1,1.33,0c.86,0,2.09.16,3.61.33a69.5,69.5,0,0,1,22.93,6.54c1.39.66,2.49,1.22,3.25,1.63A6.3,6.3,0,0,1,361.22,136.9Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.09,137.66a17,17,0,0,1-2.58-.53c-1.58-.37-3.77-.85-6.21-1.26s-4.67-.73-6.28-1a15.43,15.43,0,0,1-2.6-.45,12.19,12.19,0,0,1,2.64.08c1.63.14,3.87.38,6.33.81a56.45,56.45,0,0,1,6.21,1.42A11.6,11.6,0,0,1,345.09,137.66Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.68,86.37l.84-.05,2.5-.08c2.2,0,5.4,0,9.48.21a151.6,151.6,0,0,1,33.3,6l.18.06,0,.19c-2.5,14.33-5.48,31.36-8.66,49.58-.13.74-.26,1.48-.39,2.2l0,.28-.28-.07a216.25,216.25,0,0,0-22.23-4.59c-7.17-1.1-14-1.88-20.38-2.28l-.25,0,0-.24c1.75-15.29,3.22-28.09,4.25-37.1.52-4.46.94-8,1.22-10.4.14-1.18.26-2.09.33-2.73,0-.29.07-.52.09-.7s0-.23,0-.22a1.18,1.18,0,0,1,0,.25c0,.18,0,.42-.07.72-.06.65-.16,1.58-.28,2.78-.25,2.44-.63,6-1.1,10.46-1,9-2.36,21.75-4,37l-.22-.25c6.39.38,13.25,1.15,20.43,2.24a217.17,217.17,0,0,1,22.29,4.58l-.32.21c.13-.72.26-1.46.39-2.2,3.21-18.22,6.21-35.24,8.73-49.56l.15.25a154.65,154.65,0,0,0-33.18-6.13c-4.06-.27-7.28-.34-9.44-.33h-3.36Z",
    style: {
      fill: "#31859B"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-27"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "243.04 218.44 278.44 226.28 283.85 218.44 282.98 208.35 277.6 203.43 259.06 203.43 241.74 219.03",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "243.04 218.44 278.44 226.28 283.85 218.44 282.98 208.35 277.6 203.43 259.06 203.43 241.74 219.03"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M297,145.54l44.69-6,7-2s16.11-3.54,17.61-4.08c1.74-.62,2.46.07,2.64.72.29,1-.69,2.17-2.17,2.75-.5.2-8.67,3-8.67,3a20,20,0,0,1,2.76.8c1.95.66,3.82,3.18,4.76,6.12s.95,3.84-.18,4.26a1.57,1.57,0,0,1-1.3-.18,3.1,3.1,0,0,1-1.34-1.68c-1.57-4.69-4.5-5.06-4.5-5.06l-.92.26s3,2.11,3,4.67a2.86,2.86,0,0,1-.24,1.09,3.87,3.87,0,0,1-4.31,5.09c-.64-.12-1.34-.5-1.43-1.14a2,2,0,0,1,.21-1,4.64,4.64,0,0,0,.16-.53l-2.68.37s-6.07.5-8.68,1l-41.84,12.6A10.84,10.84,0,0,1,288,159.22h0A10.83,10.83,0,0,1,297,145.54Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.74,140.66a2.25,2.25,0,0,0,1.93,1.78c.92.19,1.88.07,2.81.19,2.78.38,4.95,2.91,7.74,3.15.39,0,.89,0,1-.42s-.19-.67-.46-.91l-7-6.17",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.79,138.28a4.81,4.81,0,0,1,.82.59c.5.41,1.23,1,2.11,1.76l3.09,2.65.88.77c.27.27.73.5.81,1.14a.79.79,0,0,1-.48.74,1.64,1.64,0,0,1-.75.12,5.59,5.59,0,0,1-1.34-.27,35.69,35.69,0,0,1-4.47-2.26,6.84,6.84,0,0,0-2-.66c-.65-.1-1.29-.08-1.87-.12a3.29,3.29,0,0,1-2.55-1.1c-.41-.57-.33-1-.31-1a2.91,2.91,0,0,0,.47.84,3.13,3.13,0,0,0,2.4.86,18.71,18.71,0,0,1,1.92.06,7.39,7.39,0,0,1,2.14.65,40.47,40.47,0,0,0,4.42,2.21,5.89,5.89,0,0,0,1.21.24c.39,0,.72-.11.68-.31s-.32-.52-.62-.78l-.88-.78-3-2.74-2-1.88C349,138.57,348.76,138.31,348.79,138.28Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.35,144.39a3.77,3.77,0,0,1,1.76,0,2.91,2.91,0,0,1,1.53,1,7.37,7.37,0,0,1,1.1,2.09,12.26,12.26,0,0,0,1,2.22,3.9,3.9,0,0,0,1.46,1.41,1.5,1.5,0,0,0,1.37,0c.29-.15.4-.3.39-.31s-.16.08-.44.19a1.49,1.49,0,0,1-1.21-.12,3.88,3.88,0,0,1-1.3-1.36,12.74,12.74,0,0,1-1-2.19,7.36,7.36,0,0,0-1.18-2.16,3.13,3.13,0,0,0-1.71-1.09,2.86,2.86,0,0,0-1.37,0C357.49,144.27,357.34,144.37,357.35,144.39Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.39,136.7a8.89,8.89,0,0,0-1.63.55l-3.88,1.43L358,140.05a8.34,8.34,0,0,0-1.6.61,8,8,0,0,0,1.68-.38c1-.29,2.42-.73,3.94-1.28s2.89-1.09,3.86-1.52A7.53,7.53,0,0,0,367.39,136.7Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.17,146.88s.12.16.35.41a1.59,1.59,0,0,1,.51,1.23.85.85,0,0,1-.53.66,4.8,4.8,0,0,1-1.08.3,1.91,1.91,0,0,0-1.21.64,1.66,1.66,0,0,0-.2,1.47,1.86,1.86,0,0,0,1,1.08,2.25,2.25,0,0,0,1.34.2,7.61,7.61,0,0,0,2.07-.77,4.42,4.42,0,0,0,1.2-.89,1.14,1.14,0,0,0,.28-.47s-.13.15-.38.37a5,5,0,0,1-1.21.77,7.88,7.88,0,0,1-2,.68,1.84,1.84,0,0,1-2-1.07,1.33,1.33,0,0,1,.14-1.17,1.61,1.61,0,0,1,1-.53,4.89,4.89,0,0,0,1.14-.36,1.13,1.13,0,0,0,.64-.88,1.71,1.71,0,0,0-.65-1.36C356.35,147,356.18,146.86,356.17,146.88Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.21,152.45s-.19,0-.44.21a1.5,1.5,0,0,0-.5,1.24,2,2,0,0,0,1.19,1.59,3.25,3.25,0,0,0,2.42,0,3.92,3.92,0,0,0,1.93-1.47,3.76,3.76,0,0,0,.65-1.86,3.43,3.43,0,0,0-.15-1.32,1.08,1.08,0,0,0-.2-.44,6.94,6.94,0,0,1,.11,1.73,3.7,3.7,0,0,1-2.45,3,3,3,0,0,1-2.18,0,1.75,1.75,0,0,1-1.08-1.32,1.42,1.42,0,0,1,.35-1.12C355.06,152.54,355.23,152.48,355.21,152.45Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.78,148.78s0-.32-.29-.78a3.28,3.28,0,0,0-1.63-1.33l0,.3a8,8,0,0,0,1-.56,7.39,7.39,0,0,0,2.8-2.89,19,19,0,0,1-3,2.6c-.34.21-.67.4-1,.56l-.34.18.36.12a3.42,3.42,0,0,1,1.57,1.14C347.62,148.51,347.73,148.79,347.78,148.78Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.69,144c-.06-.06-.53.46-.59,1.29s.34,1.4.42,1.35-.13-.61-.07-1.33S361.78,144.06,361.69,144Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.18,159.55s-6.52-10.57-7.68-11.47-11.49-4.68-12.37-4.4-13.4,2.41-12,3.9,10.17-.13,10.17-.13l1.18.59s-7.55,1.2-9.14,2.12-1,2.63.43,2.49,7.93-1.41,8.32-1.14-7.13,1.77-7.94,2.24c-1.09.65-1.2,2.58.18,2.49.81-.06,7.9-1.89,7.9-1.89a61.14,61.14,0,0,0-6.14,2.66c-.85.81-.18,2,1,1.76.84-.18,4.81-2.08,5.93-2.32,0,0,1,.28,2,2.4.44,1,2.46,7.15,6.15,7.07,3.27-.07,6.48,2.62,6.48,2.62Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.19,147.61a5.72,5.72,0,0,0,2.28.63,13,13,0,0,0,2.58.11c1-.11,2-.25,3.1-.41l2.34-.34h-.14a32.68,32.68,0,0,0,5.4,1.69,34.37,34.37,0,0,0-5.21-2.22l-.06,0h-.08l-2.32.31-3.07.45a16.2,16.2,0,0,1-2.5,0C122.09,147.73,121.21,147.52,121.19,147.61Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.29,158.3a2.51,2.51,0,0,1-2.91,0c-.89-.54-1.58-1.36-2.43-2-2.54-1.8-6.21-1.37-8.67-3.29-.34-.26-.68-.7-.49-1.09s.66-.4,1.07-.39l10.31.24",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.17,151.81a4.71,4.71,0,0,0-1.11-.14c-.72,0-1.76-.11-3-.16l-4.51-.18-1.31,0a2,2,0,0,0-1.51.32.88.88,0,0,0-.17,1,1.76,1.76,0,0,0,.52.67,6.87,6.87,0,0,0,1.29.79,39.72,39.72,0,0,0,5.35,1.53,7.87,7.87,0,0,1,2.11,1c.6.41,1.1.91,1.61,1.32a3.65,3.65,0,0,0,2.9,1c.77-.14,1-.56,1-.56a3.22,3.22,0,0,1-1,.34,3.58,3.58,0,0,1-2.6-1.12c-.47-.41-1-.93-1.6-1.4a8,8,0,0,0-2.23-1.08,45.34,45.34,0,0,1-5.25-1.54,6.6,6.6,0,0,1-1.18-.71c-.33-.27-.49-.64-.31-.78s.65-.17,1.09-.16l1.3,0,4.52,0c1.28,0,2.32,0,3,0A4.21,4.21,0,0,0,145.17,151.81Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204,393.78,201.63,420l-7.87,20.21a2.7,2.7,0,0,0,1.71,3.55h0a2.7,2.7,0,0,0,2.44-.42c4.43-3.37,20.66-15.87,20.73-17.8C218.72,423.31,223,398,223,398Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.47,443.77l23.37-20-.12,1.11a4.1,4.1,0,0,1-1.26,2.51c-1.88,1.76-7.19,6.52-19.47,16a2.69,2.69,0,0,1-2.52.41Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.43,414.73a1.64,1.64,0,0,0-.68,2.07,1.56,1.56,0,0,0,2,.69,1.72,1.72,0,0,0,.72-2.19,1.63,1.63,0,0,0-2.21-.49",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M202.76,433c-.16.06-.59-1.38-2.07-2.3a8.29,8.29,0,0,0-2.94-.92c0-.06.34-.23,1-.25a4.2,4.2,0,0,1,2.3.69,4.1,4.1,0,0,1,1.57,1.8C202.83,432.62,202.82,433,202.76,433Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.49,436.31c-.13.1-.88-.85-2.19-1.39a22.67,22.67,0,0,0-2.51-.62,3,3,0,0,1,2.74.09C200,435,200.64,436.26,200.49,436.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.74,428.92a26.83,26.83,0,0,0-3.24-2.37c-1.94-1.05-3.79-1.17-3.77-1.35a6,6,0,0,1,4.05.84A6,6,0,0,1,206.74,428.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.13,421c-.09.15-1.46-.62-3.34-.9s-3.41,0-3.45-.17a6.72,6.72,0,0,1,6.79,1.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209,413.33a13,13,0,0,0-3.45-1,13.45,13.45,0,0,0-3.57.47c0-.06.28-.35.93-.63a5.68,5.68,0,0,1,2.68-.42,5.94,5.94,0,0,1,2.59.83C208.8,412.93,209.07,413.27,209,413.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.79,410.84a2.2,2.2,0,0,1,.08-1,7,7,0,0,1,1.08-2.5,3.14,3.14,0,0,1,1.47-1.31,1.1,1.1,0,0,1,1.19.38,1.76,1.76,0,0,1,.28,1.23,3.82,3.82,0,0,1-3.72,3.13,4.43,4.43,0,0,1-4.06-2.79,1.56,1.56,0,0,1,.07-1.28,1.07,1.07,0,0,1,1.17-.43,3.67,3.67,0,0,1,1.62,1.09,7.61,7.61,0,0,1,1.56,2.24,2.47,2.47,0,0,1,.3.95,12.4,12.4,0,0,0-2.14-2.9,3.47,3.47,0,0,0-1.44-.91.57.57,0,0,0-.64.23,1.06,1.06,0,0,0,0,.84,3.93,3.93,0,0,0,3.54,2.38,3.31,3.31,0,0,0,3.2-2.61,1.27,1.27,0,0,0-.16-.86.58.58,0,0,0-.65-.22,2.72,2.72,0,0,0-1.27,1.08A10.21,10.21,0,0,0,205.79,410.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.14,409.17l19.63-155.45-6.28-36.14-37,2L199.86,406.3a2.83,2.83,0,0,0,2.3,2.87l21.56,3.33A3.87,3.87,0,0,0,228.14,409.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.2,258.93l35.71,35.34-51.37,12.49,3.65,25.92,69.54-9.46a21.92,21.92,0,0,0,14.8-8.89h0a21.88,21.88,0,0,0,.34-25.12l-54.18-79.52-24.2,7.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.23,249.94a20.17,20.17,0,0,1,1.24,4.44,19.48,19.48,0,0,1,.73,4.55,21.07,21.07,0,0,1-1.24-4.44A20.83,20.83,0,0,1,245.23,249.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,310l.85-.28,2.5-.78,9.58-2.91,34.86-10.48-.09.33-42.86-45.65.45-.14c-.85,7.17-1.74,14.66-2.64,22.3-4.42,37-8.58,70.52-11.79,94.74-1.6,12.11-3,21.9-4,28.66-.57,3.36-1,6-1.34,7.75-.18.87-.33,1.53-.43,2s-.16.68-.16.68,0-.24.11-.69.22-1.14.38-2c.36-1.76.7-4.39,1.24-7.76,1-6.77,2.32-16.56,3.86-28.68,3.13-24.22,7.22-57.73,11.64-94.75.91-7.64,1.8-15.13,2.65-22.3l.06-.55.38.4L288,295.62l.22.24-.31.09L253,306.27l-9.62,2.81-2.51.72C240.33,310,240,310,240,310Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.47,406.24c-.14,0,3.94-33,9.11-73.69s9.48-73.64,9.62-73.62-3.93,33-9.1,73.69S228.62,406.25,228.47,406.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.41,233.49a12,12,0,0,1,.82,2.41c.44,1.5,1,3.61,1.5,5.95s.89,4.48,1.12,6a11.58,11.58,0,0,1,.25,2.53,12.93,12.93,0,0,1-.61-2.47c-.37-1.71-.8-3.74-1.27-6s-1-4.26-1.34-6A12,12,0,0,1,241.41,233.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.7,230.44s.5-.49,1.45-.16a1.69,1.69,0,0,1,1.08,1.28,1.85,1.85,0,0,1-.81,1.9,1.79,1.79,0,0,1-2-.21,1.52,1.52,0,0,1-.46-1.61,1.49,1.49,0,0,1,.67-.89c.23-.13.38-.13.39-.1a2,2,0,0,0-.7,1.07,1.15,1.15,0,0,0,.41,1.16,1.36,1.36,0,0,0,1.48.13,1.42,1.42,0,0,0,.6-1.37,1.35,1.35,0,0,0-.76-1A2.67,2.67,0,0,0,243.7,230.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.43,300.32c-.11.11-2.12-1.74-5-3.4s-5.48-2.52-5.43-2.67a15.55,15.55,0,0,1,5.7,2.22A15.74,15.74,0,0,1,293.43,300.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.25,111.61l-20.5,9.9,8.84,61.68-3.47,27.68a10.8,10.8,0,0,0,3.61,9.49h0l33.11-.65L261,207l10.65-1.8-4.36-21.07,2-29.89,24.23,12.93a8.43,8.43,0,0,0,6.09.73L344,156.37l-2.31-17.12-40.22,4.55-30.63-27.06-22.8-5.13L244,104.9H220.67L219,106.12a4.93,4.93,0,0,0-1.69,2.31Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.75,121.51a24.61,24.61,0,0,0-9.23,12c-2.34,7.28-7.63,36.71-7.63,36.71L155.6,155.8l-13.42,14.11,31,27.38a15.79,15.79,0,0,0,17.29,2.39h0a15.8,15.8,0,0,0,8.79-12.09l3.81-27.91Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.69 209.69 264.25 207.57 248.92 210.4 246.1 216.93 265.69 209.69",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.73,220.36c13.7,5.51,28.33,3.48,41.37-3.43,3.94-2.09,7.59-4.68,11.55-6.74s8.34-3.57,12.79-3.26,8.93,2.76,10.71,6.85,0,9.65-4.19,11.18l1.48,1.32c6.15-2.86,9.07-11.14,6.07-17.23-2.3-4.66-7.14-7.45-10.68-11.26-5.21-5.6-5.75-16.44-5.79-24.88",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.78,123.54a6.23,6.23,0,0,1-1,0,3.88,3.88,0,0,0-2.43,1.12,5.72,5.72,0,0,0-1.21,3.91,13.26,13.26,0,0,0,1.11,5.25l.39.86-.75-.56a40.35,40.35,0,0,1-5.17-4.57,38.09,38.09,0,0,1-7.94-12.16,27.78,27.78,0,0,1-1.29-4.22,10.69,10.69,0,0,1-.23-1.61,47.5,47.5,0,0,0,1.86,5.69,40.08,40.08,0,0,0,8,11.94,42.44,42.44,0,0,0,5.08,4.53l-.37.31a11.86,11.86,0,0,1-.85-2.81,12.29,12.29,0,0,1-.23-2.65,5.9,5.9,0,0,1,1.41-4.12,3.85,3.85,0,0,1,2.63-1.07A4.34,4.34,0,0,1,234.78,123.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236,123.54c1.69-.73,4.19.34,5.4,1.72.8.92,1.25,2.18,2.3,2.78s4.39,1.07,5.36.33c0,0,.59-2.85.91-4a88.54,88.54,0,0,0,2.27-13.68c-3.22-1.57-2.33-3.63-8.14-3.23a14.78,14.78,0,0,1,.21,8.18",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.32,115.61c-.06,0,.21-.77.33-2.19a16.06,16.06,0,0,0-.72-5.93l-.07-.24h.24a9.92,9.92,0,0,1,4.28.38,6.51,6.51,0,0,1,2,1.43,7.83,7.83,0,0,0,2,1.38l.16.08,0,.17c-.26,2.43-.55,5.08-1,7.82-.3,1.79-.66,3.52-1.08,5.17s-.75,3.24-1.1,4.74l0,.1-.06.05a3.18,3.18,0,0,1-1.72.41,10.5,10.5,0,0,1-1.6-.1,10.23,10.23,0,0,1-1.5-.33,3.22,3.22,0,0,1-1.31-.71,13.23,13.23,0,0,1-1.54-2.12,5.42,5.42,0,0,0-1.58-1.43,5.64,5.64,0,0,0-2.88-.9,5.77,5.77,0,0,0-1.08.16,2.24,2.24,0,0,1,1.08-.31,5.47,5.47,0,0,1,3,.8,5.57,5.57,0,0,1,1.71,1.48,13.1,13.1,0,0,0,1.53,2,4.9,4.9,0,0,0,2.6.9,9.68,9.68,0,0,0,1.53.08,2.89,2.89,0,0,0,1.44-.33l-.09.14c.34-1.51.66-3.13,1.07-4.77s.77-3.36,1.06-5.14c.46-2.72.76-5.36,1-7.78l.14.25A8.49,8.49,0,0,1,250,109.4a5.89,5.89,0,0,0-1.83-1.36,9.82,9.82,0,0,0-4.08-.42l.17-.25a15.59,15.59,0,0,1,.57,6.07,11.12,11.12,0,0,1-.34,1.63A2.32,2.32,0,0,1,244.32,115.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.48,210s0-.39,0-1.14a7.07,7.07,0,0,0-1-3.09,10.4,10.4,0,0,0-3.68-3.55,15.52,15.52,0,0,0-6.56-1.8c-2.54-.23-5.36-.09-8.39-.3a31.63,31.63,0,0,1-9.46-2,19.52,19.52,0,0,1-8.53-6.38,14.85,14.85,0,0,1-2.45-5.13,19.62,19.62,0,0,1-.56-5.83c.15-4,1.06-7.71,1.61-11.35a86.38,86.38,0,0,0,1-10.56,87.59,87.59,0,0,0-4.27-29.68c-.42-1.37-.81-2.41-1.06-3.12-.12-.34-.21-.61-.28-.82a1.2,1.2,0,0,1-.08-.28s.05.08.13.26.19.47.33.8c.28.7.7,1.73,1.16,3.1a83,83,0,0,1,3.12,11.76,87,87,0,0,1,1.43,18,85.57,85.57,0,0,1-1,10.63c-.54,3.66-1.44,7.4-1.59,11.29a16.24,16.24,0,0,0,2.9,10.64,19,19,0,0,0,8.3,6.23,31.19,31.19,0,0,0,9.31,2c3,.22,5.82.11,8.4.37A15.7,15.7,0,0,1,274,202a10.41,10.41,0,0,1,3.7,3.7,6.85,6.85,0,0,1,.92,3.18,4.12,4.12,0,0,1-.05.87C278.51,209.94,278.49,210,278.48,210Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.52,191.79a8.9,8.9,0,0,1-1.15,1.2c-.38.37-.86.82-1.44,1.31s-1.22,1.08-2,1.65a54.71,54.71,0,0,1-5.53,3.83,56.51,56.51,0,0,1-15.16,6.35,53.83,53.83,0,0,1-6.61,1.25c-.95.15-1.81.2-2.57.26s-1.41.1-1.95.11a9.69,9.69,0,0,1-1.66,0,11.52,11.52,0,0,1,1.65-.19c.53,0,1.18-.09,1.93-.19s1.61-.16,2.55-.33a62.12,62.12,0,0,0,6.54-1.36,64.91,64.91,0,0,0,7.73-2.63,63.63,63.63,0,0,0,7.3-3.67,62.22,62.22,0,0,0,5.56-3.7c.77-.55,1.43-1.11,2-1.58s1.09-.89,1.49-1.24A11.89,11.89,0,0,1,263.52,191.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.08,159a1.93,1.93,0,0,1-.09.55l-.35,1.56a22,22,0,0,1-.66,2.44c-.3.94-.59,2-1.06,3.18-.23.58-.46,1.19-.7,1.82s-.57,1.26-.86,1.93c-.58,1.35-1.34,2.71-2.11,4.16a57.69,57.69,0,0,1-13.68,16.31c-1.3,1-2.51,2-3.74,2.8-.6.41-1.17.83-1.75,1.19l-1.67,1c-1,.67-2.07,1.15-2.95,1.61a24,24,0,0,1-2.28,1.07l-1.48.62a3.05,3.05,0,0,1-.53.18,2.45,2.45,0,0,1,.49-.28l1.43-.7c.63-.29,1.39-.66,2.24-1.15s1.86-1,2.89-1.66l1.64-1c.57-.36,1.13-.79,1.73-1.2,1.2-.81,2.39-1.8,3.67-2.82a65.3,65.3,0,0,0,7.51-7.48,66.39,66.39,0,0,0,6.06-8.69c.78-1.44,1.55-2.78,2.13-4.11.31-.66.63-1.29.89-1.91l.72-1.8c.5-1.13.81-2.2,1.13-3.13s.57-1.74.75-2.41l.44-1.53A2,2,0,0,1,257.08,159Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.91,225.38a6,6,0,0,1-1.83-1.36,13.83,13.83,0,0,1-4.17-9.93,6.26,6.26,0,0,1,.3-2.25c.09,0,0,.87.07,2.24a15.67,15.67,0,0,0,4.07,9.69C214.28,224.78,215,225.31,214.91,225.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.18,217.59c.15,0-.13,1.33,0,2.9s.62,2.8.48,2.87a6,6,0,0,1-.49-5.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.31,181.79a1.6,1.6,0,0,1-.12-.47c-.07-.37-.15-.82-.25-1.36-.21-1.26-.5-3-.84-5-.7-4.23-1.7-10.07-2.9-16.5S197.83,146.21,197,142c-.42-2-.77-3.72-1-5-.11-.54-.19-1-.26-1.35a1.51,1.51,0,0,1-.06-.49,1.9,1.9,0,0,1,.16.46c.1.37.21.81.35,1.34.3,1.16.71,2.85,1.19,4.94,1,4.18,2.19,10,3.4,16.42s2.13,12.3,2.74,16.54c.31,2.13.54,3.85.68,5,.06.55.11,1,.15,1.38A1.6,1.6,0,0,1,204.31,181.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.31,181.79a2.75,2.75,0,0,1-.05-.49c0-.39,0-.86,0-1.42,0-1.24,0-3,0-5.23,0-4.41.24-10.5.75-17.21s1.18-12.77,1.7-17.15c.27-2.13.49-3.88.66-5.18q.12-.84.21-1.41a2.34,2.34,0,0,1,.1-.48,1.59,1.59,0,0,1,0,.5c0,.38-.07.85-.11,1.41-.12,1.31-.29,3.06-.49,5.2-.43,4.38-1,10.44-1.55,17.15s-.76,12.78-.9,17.18c-.06,2.14-.11,3.9-.15,5.22l-.05,1.42A1.61,1.61,0,0,1,268.31,181.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.35,184.37c-.17.07-1.49-3.57-4-7.53s-5.55-6.45-5.42-6.58a9.18,9.18,0,0,1,2,1.59,27.5,27.5,0,0,1,3.9,4.7,32.54,32.54,0,0,1,2.8,5.42A10.08,10.08,0,0,1,188.35,184.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.07,180a19.1,19.1,0,0,1-1.12-2,15.48,15.48,0,0,0-3.46-4,21.9,21.9,0,0,0-4.57-2.79,13.18,13.18,0,0,1-2-1,7.84,7.84,0,0,1,2.17.64,17.51,17.51,0,0,1,4.76,2.73,13.44,13.44,0,0,1,3.45,4.27A6.52,6.52,0,0,1,190.07,180Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.37,156s-.05.16-.21.44a4.29,4.29,0,0,1-.91,1.07,6.07,6.07,0,0,1-4.9,1.32,9.49,9.49,0,0,1-6.16-4.35,21.2,21.2,0,0,1-2-4c-.28-.73-.56-1.47-.8-2.25a6.22,6.22,0,0,1-.28-2.52,3.47,3.47,0,0,1,1.22-2.27,2.89,2.89,0,0,1,2.47-.44,4.86,4.86,0,0,1,3.29,3.12,4.69,4.69,0,0,1-.41,4.09,5.11,5.11,0,0,1-2.85,2.19,4.53,4.53,0,0,1-3-.14,5,5,0,0,1-1.85-1.26,3.9,3.9,0,0,1-.78-1.17c-.13-.3-.17-.46-.15-.47a6.39,6.39,0,0,0,1.07,1.5,5.07,5.07,0,0,0,1.81,1.13,4.34,4.34,0,0,0,2.75.06,4.73,4.73,0,0,0,2.59-2.06,4.25,4.25,0,0,0,.33-3.7,4.36,4.36,0,0,0-3-2.79,2.38,2.38,0,0,0-2,.36,2.92,2.92,0,0,0-1,1.92c-.18,1.55.52,3.07,1,4.51a20,20,0,0,0,2,4,9.23,9.23,0,0,0,5.82,4.26,6,6,0,0,0,4.71-1.12A7.56,7.56,0,0,0,200.37,156Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.69,171.33l-.28.23c-.2.17-.48.38-.83.65a22.1,22.1,0,0,1-3.44,2.16,10.53,10.53,0,0,1-2.81.94,7.35,7.35,0,0,1-3.51-.23,12.38,12.38,0,0,1-6.33-5.58,20.39,20.39,0,0,1,.18-21.25,11,11,0,0,1,4.71-4.4,6.14,6.14,0,0,1,3.37-.43,4.61,4.61,0,0,1,3,1.71,4.9,4.9,0,0,1,.94,3.41,7.68,7.68,0,0,1-1.08,3.4,11.11,11.11,0,0,1-5.56,4.51,14.31,14.31,0,0,1-7.14.74,14.65,14.65,0,0,1-6.43-2.67,22.06,22.06,0,0,1-7.57-10.6,12.88,12.88,0,0,1-.92-6.07,6.08,6.08,0,0,1,1.17-2.76,4.2,4.2,0,0,1,2.44-1.59,5.34,5.34,0,0,1,5,1.74,5.71,5.71,0,0,1,1.21,4.79,7.59,7.59,0,0,1-2.05,4,9.72,9.72,0,0,1-3.38,2.21,15.23,15.23,0,0,1-6.35,1,36.62,36.62,0,0,1-4-.41l-1.05-.17-.35-.07.36,0,1.05.12c.92.09,2.28.27,4,.31a15.45,15.45,0,0,0,6.24-1,9.37,9.37,0,0,0,3.25-2.17,7.27,7.27,0,0,0,1.93-3.87,5.36,5.36,0,0,0-1.15-4.47,5,5,0,0,0-4.64-1.58,4.6,4.6,0,0,0-3.25,4,12.16,12.16,0,0,0,.92,5.84,21.6,21.6,0,0,0,7.4,10.35,14.27,14.27,0,0,0,6.22,2.56,13.69,13.69,0,0,0,6.87-.71,10.52,10.52,0,0,0,5.3-4.28,7.3,7.3,0,0,0,1-3.18,4.34,4.34,0,0,0-.83-3.05,4.15,4.15,0,0,0-2.7-1.53,5.67,5.67,0,0,0-3.1.39,10.53,10.53,0,0,0-4.49,4.2,19.57,19.57,0,0,0-3.05,11.1,19.83,19.83,0,0,0,2.77,9.7,12.1,12.1,0,0,0,6.11,5.49,8.26,8.26,0,0,0,6.14-.61,24.5,24.5,0,0,0,3.47-2.07l.86-.6A1.68,1.68,0,0,1,239.69,171.33Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.1,115.22a3.38,3.38,0,0,1-.32.89,13.72,13.72,0,0,1-1.29,2.25,16.42,16.42,0,0,1-14.82,7.07,13.65,13.65,0,0,1-2.55-.41,3,3,0,0,1-.9-.32c0-.09,1.32.29,3.47.37a17.21,17.21,0,0,0,14.51-6.92C211.49,116.43,212,115.17,212.1,115.22Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.87,119.47a9.23,9.23,0,0,0-2.82,1.39,9.09,9.09,0,0,0-1.83,2.56c-.06,0-.08-.4.12-1a4.67,4.67,0,0,1,3.54-3C226.49,119.33,226.87,119.41,226.87,119.47Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,125.35a2.14,2.14,0,0,1-.85-.39,6.92,6.92,0,0,1-1.88-1.73,6.83,6.83,0,0,1-1.39-3.54,3.38,3.38,0,0,1,.62-2.25,2.31,2.31,0,0,1,2.31-1,2.55,2.55,0,0,1,1.82,1.75,2.39,2.39,0,0,1-.46,2.3,3.23,3.23,0,0,1-3.62,1,4.13,4.13,0,0,1-2-1.64,2,2,0,0,1-.37-.86s.18.29.54.74a4.17,4.17,0,0,0,1.93,1.41,2.87,2.87,0,0,0,3.13-.91,1.94,1.94,0,0,0,.35-1.85,2.09,2.09,0,0,0-1.45-1.39,1.81,1.81,0,0,0-1.8.78,3,3,0,0,0-.54,1.91,6.68,6.68,0,0,0,1.21,3.36A10.36,10.36,0,0,0,248,125.35Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252,113.68a12.67,12.67,0,0,0-3.31-2.31,13,13,0,0,0-4-.68c0-.06.43-.24,1.2-.29a6.55,6.55,0,0,1,3,.49,6.81,6.81,0,0,1,2.46,1.73C251.87,113.2,252.06,113.65,252,113.68Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.5,125.32s-.06.05-.19.12l-.6.32c-.54.26-1.34.62-2.41,1a29.06,29.06,0,0,1-9.42,1.77,13.76,13.76,0,0,1-3.2-.31,7,7,0,0,1-3.15-1.54,4.68,4.68,0,0,1-1.55-3.42,5.81,5.81,0,0,1,1.33-3.76,7.73,7.73,0,0,1,8-2,9.3,9.3,0,0,1,6.38,6.18,9.13,9.13,0,0,1-1.91,8.67,14,14,0,0,1-7.4,4,43.22,43.22,0,0,1-7.59.77,41.55,41.55,0,0,0-6.55.64,13.28,13.28,0,0,0-8.05,4.59,9.56,9.56,0,0,0-1.54,3.11.67.67,0,0,1,0-.23c0-.15.07-.38.16-.66a8.44,8.44,0,0,1,1.18-2.34,13.29,13.29,0,0,1,8.15-4.83,40,40,0,0,1,6.6-.71,42.66,42.66,0,0,0,7.5-.8,13.59,13.59,0,0,0,7.13-3.86,8.62,8.62,0,0,0,1.79-8.18,8.79,8.79,0,0,0-6-5.84,7.28,7.28,0,0,0-7.46,1.86,5.32,5.32,0,0,0-1.24,3.45,4.22,4.22,0,0,0,1.38,3.11,6.67,6.67,0,0,0,3,1.47,13.36,13.36,0,0,0,3.1.33,30.3,30.3,0,0,0,9.36-1.59c1.06-.37,1.87-.7,2.42-.93A5.91,5.91,0,0,1,279.5,125.32Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.56,164.59c-.09,0-.43-.84-1.35-2A10.28,10.28,0,0,0,243,158.74c-1.45.28-2.29.7-2.33.62a5.4,5.4,0,0,1,2.25-1,9.87,9.87,0,0,1,10.6,4A5.39,5.39,0,0,1,254.56,164.59Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.24,172.15a4.87,4.87,0,0,1-1.37,2,8.39,8.39,0,0,1-11,.87,5,5,0,0,1-1.67-1.78c.07-.07.64.68,1.88,1.47a8.79,8.79,0,0,0,5.39,1.4,8.89,8.89,0,0,0,5.11-2.23C265.71,172.92,266.16,172.09,266.24,172.15Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.28,152.25c0,.08-.65-.29-1.71-.57a7.34,7.34,0,0,0-7.66,2.45c-.7.85-1,1.49-1.06,1.46a3.54,3.54,0,0,1,.77-1.68,7,7,0,0,1,8.06-2.58A3.56,3.56,0,0,1,269.28,152.25Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.54,143.05a5.19,5.19,0,0,1,.18.74,5.3,5.3,0,0,1,.12.92,7.31,7.31,0,0,1,0,1.27,12.6,12.6,0,0,1-2.87,7.45A13.13,13.13,0,0,1,299.7,157a13.28,13.28,0,0,1-6.24,1.43,16.8,16.8,0,0,1-12.85-6.35,10.11,10.11,0,0,1-1.81-3.47,6.59,6.59,0,0,1,.06-3.81,4.91,4.91,0,0,1,2.34-2.86,5.34,5.34,0,0,1,3.52-.41,5.87,5.87,0,0,1,3,1.57,7,7,0,0,1,1.64,2.71,9.13,9.13,0,0,1-.05,5.58,10.53,10.53,0,0,1-2.36,4,11,11,0,0,1-2.75,2.12,10.53,10.53,0,0,1-2,.82,5,5,0,0,1-.76.14,14.84,14.84,0,0,0,2.7-1.13,10.8,10.8,0,0,0,4.86-6,8.81,8.81,0,0,0,0-5.33,6.39,6.39,0,0,0-1.55-2.52,5.45,5.45,0,0,0-2.74-1.43,4.93,4.93,0,0,0-3.2.38,4.38,4.38,0,0,0-2.08,2.58,6,6,0,0,0-.05,3.51,9.45,9.45,0,0,0,1.72,3.29,16.41,16.41,0,0,0,12.44,6.19,12.73,12.73,0,0,0,10.27-4.74,12.79,12.79,0,0,0,2.95-7.23A20.07,20.07,0,0,0,306.54,143.05Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.25,163.76a2.84,2.84,0,0,1-.61-.69,7.18,7.18,0,0,1-1.09-2.26,9.23,9.23,0,0,1-.15-3.72,34.17,34.17,0,0,1,1-4.42,31.74,31.74,0,0,1,3.58-7.38c.56-.88,1-1.59,1.38-2.06a3.6,3.6,0,0,1,.57-.72,23.92,23.92,0,0,1-1.63,3,37,37,0,0,0-3.4,7.34,40.89,40.89,0,0,0-1,4.34,9.35,9.35,0,0,0,0,3.56A13.32,13.32,0,0,0,314.25,163.76Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.19,140.75a2.45,2.45,0,0,1,.3.72,12.5,12.5,0,0,1,.5,2.05A18.33,18.33,0,0,1,331,156.89a12.3,12.3,0,0,1-1.32,1.65c-.35.36-.55.55-.58.53s.67-.89,1.59-2.38a20.92,20.92,0,0,0,2.57-6.31,20.63,20.63,0,0,0,.33-6.8C333.42,141.83,333.1,140.78,333.19,140.75Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.75,187.52a2.26,2.26,0,0,1-.43-.23,12.72,12.72,0,0,0-1.22-.66,14.47,14.47,0,0,0-4.88-1.37,14.81,14.81,0,0,0-7.34,1.18,12.6,12.6,0,0,0-3.67,2.43,7.5,7.5,0,0,0-1.44,1.78,3.57,3.57,0,0,0-.5,2.2,2.62,2.62,0,0,0,1.06,1.88,2.14,2.14,0,0,0,2,.09,3.58,3.58,0,0,0,1.86-3.51,7.11,7.11,0,0,0-3.71-6,7.27,7.27,0,0,0-4.9-.64,17.24,17.24,0,0,0-1.78.57,1.74,1.74,0,0,1,.42-.27,7,7,0,0,1,1.31-.5,7.29,7.29,0,0,1,5.12.52,7.46,7.46,0,0,1,4,6.33,5.31,5.31,0,0,1-.43,2.26,3.37,3.37,0,0,1-1.7,1.73,2.65,2.65,0,0,1-2.53-.13,3.13,3.13,0,0,1-1.3-2.25,4,4,0,0,1,.57-2.51,7.77,7.77,0,0,1,1.54-1.9,13,13,0,0,1,3.83-2.5,15,15,0,0,1,7.57-1.11,13.45,13.45,0,0,1,4.93,1.56,8.82,8.82,0,0,1,1.19.75C267.63,187.39,267.77,187.5,267.75,187.52Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.37,195.79a6.51,6.51,0,0,1-1.21,2.29c-.79,1.19-1.52,2.09-1.64,2a6.51,6.51,0,0,1,1.21-2.29C270.52,196.61,271.25,195.71,271.37,195.79Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.07,210.1c-.08,0-.22-.35-.57-.87a5.17,5.17,0,0,0-4.07-2.26c-.62,0-1,.05-1,0s.35-.27,1-.34a4.55,4.55,0,0,1,4.4,2.45C284.11,209.66,284.13,210.09,284.07,210.1Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.76,205c0,.07-1.2.68-3.13,1.79a27.05,27.05,0,0,0-6.8,5.25,14.51,14.51,0,0,0-3.61,7.64,18.06,18.06,0,0,0,.06,3.57,3,3,0,0,1-.28-.94,9.06,9.06,0,0,1-.14-2.66,14,14,0,0,1,3.58-7.95,24.54,24.54,0,0,1,7-5.24c1-.51,1.82-.89,2.39-1.14A3.15,3.15,0,0,1,242.76,205Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.45,209.89s-.56-.33-1.09-1.2a6.69,6.69,0,0,1,.63-7.47,2.93,2.93,0,0,1,1.27-1c.06.08-.43.45-1,1.23a7.18,7.18,0,0,0-.59,7.07C257.1,209.37,257.52,209.83,257.45,209.89Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.49,191.77s-.18-.22-.58-.58a4.12,4.12,0,0,0-2.08-.92,5.2,5.2,0,0,0-3.49.72,10.67,10.67,0,0,0-3.31,3.5c-1,1.52-1.82,3.35-3.09,5.13a10.93,10.93,0,0,1-5.51,4.12,10.23,10.23,0,0,1-7.57-.44,10.84,10.84,0,0,1-5.57-5.94,6.47,6.47,0,0,1-.17-4.21,5.87,5.87,0,0,1,2.6-3.18,6,6,0,0,1,3.86-.89,6.4,6.4,0,0,1,3.43,1.63,8.39,8.39,0,0,1,2.71,6.29,10.36,10.36,0,0,1-1.86,5.71,11.63,11.63,0,0,1-3.62,3.4,14.61,14.61,0,0,1-3.43,1.5,16.18,16.18,0,0,1-2.31.48l-.61.07h-.22a5.72,5.72,0,0,1,.81-.17,17.56,17.56,0,0,0,2.27-.58,14.63,14.63,0,0,0,3.34-1.55,11.39,11.39,0,0,0,3.46-3.35,10.07,10.07,0,0,0,1.74-5.51,8,8,0,0,0-2.6-5.93,5.86,5.86,0,0,0-3.17-1.49,5.54,5.54,0,0,0-3.54.82,5.47,5.47,0,0,0-2.37,2.91,6,6,0,0,0,.17,3.88,10.39,10.39,0,0,0,5.3,5.65,9.71,9.71,0,0,0,7.2.44,10.47,10.47,0,0,0,5.31-3.92c1.25-1.71,2.11-3.54,3.13-5.07a10.85,10.85,0,0,1,3.48-3.55,5.35,5.35,0,0,1,3.66-.67,4.09,4.09,0,0,1,2.12,1A2.53,2.53,0,0,1,234.49,191.77Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.82,207.35a4.59,4.59,0,0,1-1.61-1.27,11,11,0,0,1-2.77-9.28,4.79,4.79,0,0,1,.65-2c.09,0-.15.77-.28,2a12.2,12.2,0,0,0,2.67,9C234.27,206.79,234.88,207.28,234.82,207.35Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.5,184.3s-.7-.34-2-.85a24,24,0,0,0-14.4-1.08,19.62,19.62,0,0,0-4.8,1.8,3.23,3.23,0,0,0-1.59,1.9,1.82,1.82,0,0,0,1,2,1.06,1.06,0,0,0,1-.32,2.49,2.49,0,0,0,.6-1.11,9.16,9.16,0,0,0,.23-2.66,11.9,11.9,0,0,0-1.28-4.91,11.48,11.48,0,0,0-2.82-3.63,11.29,11.29,0,0,0-3.49-2,12.24,12.24,0,0,0-5.79-.58c-1.38.22-2.11.53-2.12.48a2,2,0,0,1,.51-.24,11.12,11.12,0,0,1,7.53,0,11.73,11.73,0,0,1,3.64,2,12,12,0,0,1,3,3.74,12.34,12.34,0,0,1,1.36,5.11,9.71,9.71,0,0,1-.24,2.82,3.16,3.16,0,0,1-.73,1.34,1.6,1.6,0,0,1-1.56.45,2,2,0,0,1-1.19-1.07,2.63,2.63,0,0,1-.22-1.54,3.71,3.71,0,0,1,1.84-2.24,19.31,19.31,0,0,1,4.95-1.82,23.7,23.7,0,0,1,8.86-.33,22.27,22.27,0,0,1,5.73,1.68A14.15,14.15,0,0,1,238,184Q238.52,184.27,238.5,184.3Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.57,187.17s.62-.48,1.61-1.48a13.89,13.89,0,0,0,3.14-5,10.86,10.86,0,0,0-.25-8.46,10.71,10.71,0,0,0-3.19-3.94,9,9,0,0,0-5-1.89,5.77,5.77,0,0,0-2.64.55,3.38,3.38,0,0,0-1.76,1.79,2.57,2.57,0,0,0,.36,2.32,3.77,3.77,0,0,0,1.89,1.41,5.19,5.19,0,0,0,4.33-.74,7.28,7.28,0,0,0,2.63-3,15.15,15.15,0,0,0,1.25-5.74c0-.66,0-1.2.07-1.63a1.88,1.88,0,0,1,.05-.56,1.88,1.88,0,0,1,0,.56c0,.38,0,.93,0,1.63A14.5,14.5,0,0,1,162,169a7.64,7.64,0,0,1-2.72,3.18,5.6,5.6,0,0,1-4.71.83,4.18,4.18,0,0,1-2.16-1.58,3.05,3.05,0,0,1-.43-2.77,3.79,3.79,0,0,1,2-2.08,6.34,6.34,0,0,1,2.89-.61,9.46,9.46,0,0,1,5.33,2,11.16,11.16,0,0,1,3.32,4.15,10.5,10.5,0,0,1,1,4.69,12.05,12.05,0,0,1-.82,4.1,13.65,13.65,0,0,1-3.35,5,8.81,8.81,0,0,1-1.26,1C160.75,187.09,160.58,187.19,160.57,187.17Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.3,202.05a3.71,3.71,0,0,1-.78-.83,16.1,16.1,0,0,1-1.72-2.6,18.45,18.45,0,0,1,1.29-19.57,16.48,16.48,0,0,1,2-2.35A4.27,4.27,0,0,1,183,176c.07.08-1.18,1.14-2.62,3.29a19,19,0,0,0-1.27,19.19A39.23,39.23,0,0,0,181.3,202.05Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.84,180.3c-.09,0-.51-1.5-1.75-3.71a20.56,20.56,0,0,0-15.8-10.45c-2.52-.28-4.1-.06-4.1-.16a4.24,4.24,0,0,1,1.1-.19,18.35,18.35,0,0,1,3,0,19.78,19.78,0,0,1,16.1,10.65,17,17,0,0,1,1.17,2.8A4,4,0,0,1,200.84,180.3Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M228.17,208.29c-1,.41-.87,1.93-.07,2.59a4.28,4.28,0,0,0,3,.64,38.62,38.62,0,0,0,29.63-16.64c-9,7.41-20.9,10.22-32.31,12.8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M226.38,198.09c-1-1.51-.32-3.63,1-4.91a16.78,16.78,0,0,1,4.62-2.75,29.18,29.18,0,0,0,13.48-13.83c1.82-3.94,3.19-8.77,7.22-10.39a39.06,39.06,0,0,1-25.71,30.66"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M198,146.24a101.48,101.48,0,0,1-2.3,32.68,27.53,27.53,0,0,0-1.11,6.89,9.16,9.16,0,0,0,3.32,6.47c1.66-3.83,1.69-7.52,2.39-11.64.63-3.71,1.69-12.38,1.69-12.51.15-7.58-1.64-14.08-4.56-20.91"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M216.84,113.41a39.92,39.92,0,0,0,11.32,21.24c2.21,2.15,5,4.14,8.05,4a18.84,18.84,0,0,1-1.55-11.78,48.71,48.71,0,0,0,8.24,4.48,16.35,16.35,0,0,0,9.2,1L254,115.82a3.09,3.09,0,0,0-.17-1.86,1.07,1.07,0,0,0-1.59-.38,1.59,1.59,0,0,0-.31.73c-1.12,4.85-1.75,9.2-2.88,14.06-.81.8-3.3.47-4.94-.14-1.43-.53-2-1.71-2.92-2.9s-.78-1-2.18-1.58c-2.58-1.09-7.53-.22-8.61,2.09s-.26,5.36.46,7.64a34.65,34.65,0,0,1-14.59-20.24"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M271.37,136.87c-.2.4,6.23,22.08,6.23,22.08l-8.33-4.75Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M219.61,74v34.51a8.35,8.35,0,0,0,2,5.39h0a25.08,25.08,0,0,0,6.94,5.74l7,3.93,5.76-5.15a8.39,8.39,0,0,0,2.79-5.91c.1-2.52.09-5,.09-5s9.76-.7,10.68-10.32c.43-4.54.57-13.82.59-22.37A18.72,18.72,0,0,0,238.2,56l-.27,0A17.89,17.89,0,0,0,219.61,74Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.11,107.43a23.35,23.35,0,0,1-12.23-4.75s2.52,7.3,12.21,7.23Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.53,80.93a1.38,1.38,0,0,1-1.44,1.28,1.32,1.32,0,0,1-1.31-1.36,1.38,1.38,0,0,1,1.44-1.28A1.31,1.31,0,0,1,252.53,80.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.92,78.63c-.18.16-1.16-.7-2.64-.82s-2.63.54-2.77.34.12-.39.63-.7a3.79,3.79,0,0,1,2.23-.49,3.62,3.62,0,0,1,2.09.87C252.89,78.22,253,78.55,252.92,78.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.57,80.23a1.38,1.38,0,0,1-1.44,1.28,1.33,1.33,0,0,1-1.32-1.36,1.39,1.39,0,0,1,1.44-1.28A1.32,1.32,0,0,1,238.57,80.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.35,77.7c-.19.16-1.17-.69-2.65-.81s-2.62.53-2.77.33.13-.39.63-.7A3.85,3.85,0,0,1,235.8,76a3.68,3.68,0,0,1,2.09.87C238.31,77.29,238.44,77.62,238.35,77.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.81,89.12a9.57,9.57,0,0,1,2.44-.24c.38,0,.75,0,.83-.3a1.91,1.91,0,0,0-.16-1.14c-.28-1-.57-1.94-.88-3-1.21-4.23-2-7.69-1.88-7.74s1.29,3.34,2.5,7.57c.29,1,.57,2,.83,3a2.18,2.18,0,0,1,.08,1.5,1,1,0,0,1-.67.5,2.51,2.51,0,0,1-.65,0A10.32,10.32,0,0,1,242.81,89.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.37,89.78c.24,0,.11,1.62,1.39,2.87s3,1.22,3,1.44-.4.29-1.13.25a4,4,0,0,1-2.51-1.12,3.49,3.49,0,0,1-1.06-2.4C238.05,90.15,238.26,89.76,238.37,89.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.21,71.93c-.18.39-1.64.08-3.39.14s-3.2.42-3.4,0c-.09-.18.18-.54.78-.88a5.89,5.89,0,0,1,5.18-.14C239,71.4,239.29,71.74,239.21,71.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.73,74.3c-.29.31-1.28-.12-2.5-.24s-2.28,0-2.49-.33c-.1-.18.1-.51.58-.79a3.64,3.64,0,0,1,4,.46C252.75,73.78,252.86,74.14,252.73,74.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.94,64.27l-.06,0A7.6,7.6,0,0,0,227.66,69l0,.2c-.61,2.71-.77,5.51-1.4,8.22s-.51,4.78-3.23,5.39a3.6,3.6,0,0,1-3.78-1.53A2.46,2.46,0,0,1,219,80c0-6.68-1.3-9.27-.72-16.2a5.88,5.88,0,0,1,2.82-4.56c1.54-.92,3.4-1.86,5-1s3.4,4.09,4.54,5.48",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.49,78.59c-.15-.08-6.45-2.5-6.79,4.1s6.37,5.58,6.39,5.39S222.49,78.59,222.49,78.59Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.2,85.47s-.12.08-.32.16a1.12,1.12,0,0,1-.86,0A2.84,2.84,0,0,1,217.83,83a3.7,3.7,0,0,1,.41-1.63,1.33,1.33,0,0,1,.91-.84.59.59,0,0,1,.66.35c.08.19,0,.32.06.33s.15-.1.11-.37a.7.7,0,0,0-.24-.43.82.82,0,0,0-.62-.2,1.61,1.61,0,0,0-1.26,1,4,4,0,0,0-.49,1.82,3,3,0,0,0,1.53,2.94,1.26,1.26,0,0,0,1.06-.12C220.18,85.63,220.22,85.49,220.2,85.47Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.72,59.24c-1.41-2.77,3.35-6.18,6.68-6.94s7.49,1.19,10.64,2.53c2,.84,3.94,2,6.09,2a14.74,14.74,0,0,0,4.26-.71,10.83,10.83,0,0,1,4.29-.49A4,4,0,0,1,261,58.16,2.49,2.49,0,0,1,259,61.38a3.25,3.25,0,1,1,.36,6.07c1-.64,2.34.65,2.12,1.81a3.41,3.41,0,0,1-2.45,2.31c-2.85,1-6,.33-8.78-.86s-5.28-2.9-8-4.16-7.3-3.5-10.21-2.73c-2.15.56-3.8,2.95-4.93,2.29A4,4,0,0,1,225.28,63a11.62,11.62,0,0,1,.44-3.74",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.83,61.27c-.05,0-.38.45-1.15,1.16a9.06,9.06,0,0,1-3.86,2.06,8.35,8.35,0,0,1-6.26-.78c-2.15-1.18-3.9-3.35-5.95-5.43a13.74,13.74,0,0,0-7.11-4.16A7.62,7.62,0,0,0,229,55.78a5.72,5.72,0,0,0-1.84,4.13,4.22,4.22,0,0,0,.18,1.23,1.32,1.32,0,0,0,.18.4,9.93,9.93,0,0,1-.11-1.62,5.64,5.64,0,0,1,1.9-3.8,7.22,7.22,0,0,1,6.06-1.41,13.33,13.33,0,0,1,6.76,4c2,2,3.81,4.25,6.12,5.49a9,9,0,0,0,10.58-1.62,7.09,7.09,0,0,0,.78-1C259.78,61.41,259.85,61.28,259.83,61.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.84,78.17s.3-.16.59-.66a4.45,4.45,0,0,0,.53-2.36c0-2.14-1.66-4.57-1.66-7.52a6.68,6.68,0,0,1,1.06-3.87A5,5,0,0,1,224,61.85a4.34,4.34,0,0,1,2.22-.12c.53.13.8.28.83.23s-.22-.26-.75-.47a4.11,4.11,0,0,0-2.42-.09,5.34,5.34,0,0,0-3,2,7,7,0,0,0-1.22,4.23,12.11,12.11,0,0,0,.93,4.25,12.87,12.87,0,0,1,.92,3.28A5.14,5.14,0,0,1,220.84,78.17Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lines--inject-27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248,268.88l-1.49,0-4.36.06c-3.84.06-9.5.21-16.78.56s-16.18,1-26.47,2.2c-5.13.62-10.63,1.32-16.42,2.28s-11.89,2.08-18.24,3.53-13,3.17-19.72,5.38a131.66,131.66,0,0,0-20.45,8.43,66,66,0,0,0-9.8,6.27,31.23,31.23,0,0,0-8,8.78c-.25.44-.51.87-.74,1.32l-.56,1.41-.29.71c-.08.24-.12.49-.19.74l-.35,1.48a14.84,14.84,0,0,0,.3,6.11c1,4.05,3.65,7.54,6.72,10.48,6.26,5.89,14.25,10,22.54,13.42a185.79,185.79,0,0,0,26.27,8.31,345.78,345.78,0,0,0,57.33,8.44,457.19,457.19,0,0,0,58,.23,365.74,365.74,0,0,0,53.56-7,226.13,226.13,0,0,0,24.28-6.55,120.57,120.57,0,0,0,21.71-9.46,60.11,60.11,0,0,0,9.15-6.51,26.42,26.42,0,0,0,6.62-8.44l.5-1.22a7,7,0,0,0,.42-1.24l.3-1.26c.05-.21.12-.42.15-.63l0-.65a12.56,12.56,0,0,0-.38-5,17.71,17.71,0,0,0-2.11-4.51,27.28,27.28,0,0,0-3.1-3.81,46.52,46.52,0,0,0-7.32-6,75.43,75.43,0,0,0-7.76-4.62,133.43,133.43,0,0,0-15.12-6.74,230.43,230.43,0,0,0-25.36-7.82c-7.07-1.76-12.62-2.88-16.39-3.6-1.88-.37-3.33-.61-4.29-.8l-1.47-.28s2,.29,5.78,1,9.33,1.77,16.42,3.51a224.91,224.91,0,0,1,25.41,7.74,133.69,133.69,0,0,1,15.18,6.71,77.14,77.14,0,0,1,7.8,4.63,47.08,47.08,0,0,1,7.39,6.07,28,28,0,0,1,3.14,3.85A18,18,0,0,1,392,311a13,13,0,0,1,.4,5.2l-.05.66c0,.22-.1.43-.15.65l-.31,1.29a7,7,0,0,1-.43,1.27l-.5,1.25a26.93,26.93,0,0,1-6.71,8.58,60,60,0,0,1-9.22,6.58A120.9,120.9,0,0,1,353.27,346a225.37,225.37,0,0,1-24.33,6.59,365.45,365.45,0,0,1-53.63,7,456.24,456.24,0,0,1-58.07-.22,345.81,345.81,0,0,1-57.42-8.47,184.63,184.63,0,0,1-26.34-8.34c-8.31-3.46-16.34-7.57-22.68-13.53-3.11-3-5.84-6.54-6.85-10.72a15.36,15.36,0,0,1-.3-6.29l.37-1.53c.06-.26.11-.51.19-.76l.29-.73.59-1.44c.23-.46.5-.91.75-1.36a31.72,31.72,0,0,1,8.15-8.9,67.18,67.18,0,0,1,9.88-6.3,131.21,131.21,0,0,1,20.52-8.43c6.78-2.2,13.4-3.92,19.76-5.36s12.48-2.58,18.28-3.49,11.3-1.65,16.44-2.25c10.3-1.15,19.21-1.76,26.49-2.11s12.95-.44,16.79-.47H248Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.28,193.11s-.57.13-1.68.35-2.77.54-4.94,1c-4.34.9-10.73,2.29-18.84,4.51A193.11,193.11,0,0,0,112,209.18c-2.71,1.24-5.49,2.61-8.26,4.18a78.73,78.73,0,0,0-8.29,5.32,46.34,46.34,0,0,0-7.65,7,24.15,24.15,0,0,0-5.19,9.52,17.44,17.44,0,0,0,.83,11.19,28.76,28.76,0,0,0,6.92,9.69c5.92,5.67,13.43,10,21.42,13.67,16.11,7.32,34.5,12.23,54,15.89a451.63,451.63,0,0,0,62,6.84,534.73,534.73,0,0,0,67-1.19c22.86-1.91,45.11-5.27,66.05-10.77a197.65,197.65,0,0,0,30.08-10.32A103.77,103.77,0,0,0,404.4,263a51.89,51.89,0,0,0,11.45-9.66c3.19-3.73,5.54-8.3,5.68-13.12a13.33,13.33,0,0,0-.06-1.79,13,13,0,0,0-.19-1.77l-.39-1.74a12.78,12.78,0,0,0-.57-1.68,25.43,25.43,0,0,0-3.43-6.13,47.14,47.14,0,0,0-10.15-9.37,92.91,92.91,0,0,0-11.61-6.79,164.65,164.65,0,0,0-23.78-9.33c-7.84-2.45-15.48-4.4-22.82-6a439.42,439.42,0,0,0-70.61-9c-8.4-.43-14.94-.45-19.37-.56l-5-.11-1.71-.06s.58,0,1.71,0l5,.06c4.43.08,11,.06,19.38.47a434.72,434.72,0,0,1,70.68,8.85c7.35,1.62,15,3.55,22.86,6a163.64,163.64,0,0,1,23.85,9.34A92.12,92.12,0,0,1,407,217.35a47.71,47.71,0,0,1,10.25,9.45,25.72,25.72,0,0,1,3.5,6.25,11.59,11.59,0,0,1,.58,1.72l.41,1.78a12.2,12.2,0,0,1,.19,1.82,12.45,12.45,0,0,1,.07,1.83,18.65,18.65,0,0,1-1.74,7.16,26.59,26.59,0,0,1-4,6.26,52.06,52.06,0,0,1-11.56,9.76,102.91,102.91,0,0,1-13.65,7.3,199,199,0,0,1-30.15,10.37c-21,5.51-43.25,8.88-66.14,10.79a533.74,533.74,0,0,1-67,1.18,452.59,452.59,0,0,1-62-6.87c-19.55-3.69-38-8.62-54.12-16-8-3.73-15.55-8.05-21.52-13.79a29.23,29.23,0,0,1-7-9.82,17.85,17.85,0,0,1-.82-11.44,24.38,24.38,0,0,1,5.27-9.64,46.25,46.25,0,0,1,7.73-7.08,78.17,78.17,0,0,1,8.33-5.32c2.78-1.57,5.57-2.94,8.29-4.18a192.22,192.22,0,0,1,28.93-10.13c8.13-2.19,14.53-3.55,18.88-4.42S166.28,193.11,166.28,193.11Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.34,344l-5,.79c-3.27.52-8.08,1.35-14.23,2.69a182.58,182.58,0,0,0-22,6.21,104,104,0,0,0-13.1,5.7,56,56,0,0,0-6.64,4.06,34.34,34.34,0,0,0-6.11,5.44,19.82,19.82,0,0,0-2.42,3.48,13.91,13.91,0,0,0-1.49,4c-.05.36-.14.72-.17,1.09l-.07,1.1c0,.73.1,1.47.16,2.21a21.07,21.07,0,0,0,.58,2.17l.42,1.05.21.53.28.49a24.66,24.66,0,0,0,6,7.07,49.32,49.32,0,0,0,8.06,5.41,107.12,107.12,0,0,0,18.85,7.87,193.9,193.9,0,0,0,21,5.37,311.85,311.85,0,0,0,46.26,5.53,375.39,375.39,0,0,0,50-.87c17.08-1.48,33.7-4.09,49.27-8.49a124.07,124.07,0,0,0,22.2-8.46,55.88,55.88,0,0,0,9.65-6.23c.76-.57,1.41-1.27,2.11-1.9s1.27-1.38,1.91-2.06a18.14,18.14,0,0,0,2.84-4.75,12.74,12.74,0,0,0-.44-10.55,25.34,25.34,0,0,0-6.88-8c-5.51-4.38-11.77-7.33-17.88-9.78a151.08,151.08,0,0,0-18.19-5.83c-5.94-1.53-11.71-2.74-17.24-3.71a341.92,341.92,0,0,0-53-4.85l-19.53-.1s6.95-.09,19.53,0a338.68,338.68,0,0,1,53,4.75c5.55,1,11.32,2.17,17.27,3.7A150.33,150.33,0,0,1,344.83,355c6.12,2.45,12.4,5.4,17.95,9.81a25.65,25.65,0,0,1,7,8.11,13,13,0,0,1,.45,10.77,18.67,18.67,0,0,1-2.88,4.83c-.65.69-1.24,1.44-1.94,2.09s-1.35,1.34-2.12,1.91a55.83,55.83,0,0,1-9.71,6.28,124.37,124.37,0,0,1-22.25,8.49,266.93,266.93,0,0,1-49.32,8.5,376.14,376.14,0,0,1-50.06.87,313.55,313.55,0,0,1-46.29-5.55,196.21,196.21,0,0,1-21-5.4,106.21,106.21,0,0,1-18.9-7.9,50,50,0,0,1-8.09-5.45,24.73,24.73,0,0,1-6.06-7.15l-.29-.5-.21-.54-.43-1.06c-.27-.72-.38-1.48-.58-2.21s-.16-1.51-.16-2.26l.07-1.12c0-.37.12-.73.18-1.1a14,14,0,0,1,1.51-4.11,20.21,20.21,0,0,1,2.45-3.51,34.32,34.32,0,0,1,6.15-5.47,57.39,57.39,0,0,1,6.68-4.07A102.61,102.61,0,0,1,160,353.55a180.62,180.62,0,0,1,22.07-6.17c6.15-1.32,11-2.13,14.24-2.63S201.34,344,201.34,344Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.92,435.47a10.36,10.36,0,0,0-.83-3.65c-.93-2.29-3.42-5.14-7.33-7.72-7.85-5.17-21-9.51-37.52-12.17A227.81,227.81,0,0,0,259,409.26a262.26,262.26,0,0,0-31.45.58c-5.53.43-11.18,1.07-16.91,2a160,160,0,0,0-17.36,3.67c-2.91.78-5.82,1.69-8.69,2.74a69.9,69.9,0,0,0-8.49,3.7,34.34,34.34,0,0,0-7.69,5.33c-2.27,2.12-4.12,5-4.17,8.2s1.89,6.08,4.16,8.21A34.3,34.3,0,0,0,176,449a68.37,68.37,0,0,0,8.49,3.7c2.87,1.06,5.78,2,8.69,2.75a160.14,160.14,0,0,0,17.37,3.67c5.73.91,11.38,1.55,16.91,2a260.36,260.36,0,0,0,31.46.58A227.84,227.84,0,0,0,286.24,459c16.54-2.66,29.67-7,37.53-12.17,3.91-2.58,6.39-5.43,7.32-7.72a10.33,10.33,0,0,0,.83-3.64c0,.15,0,.4-.07.95a4.94,4.94,0,0,1-.21,1.16,7.35,7.35,0,0,1-.52,1.54c-.92,2.31-3.4,5.18-7.31,7.78-7.86,5.2-21,9.57-37.55,12.25a229.78,229.78,0,0,1-27.3,2.7,262.65,262.65,0,0,1-31.48-.56c-5.53-.44-11.18-1.07-16.92-2a157.58,157.58,0,0,1-17.39-3.66c-2.92-.78-5.83-1.69-8.71-2.75a71.06,71.06,0,0,1-8.52-3.71,34.89,34.89,0,0,1-7.74-5.36,15.53,15.53,0,0,1-2.94-3.75,9,9,0,0,1,0-9.22,15.57,15.57,0,0,1,3-3.74,34.89,34.89,0,0,1,7.74-5.36,71.63,71.63,0,0,1,8.51-3.71c2.89-1.06,5.8-2,8.72-2.75a160.25,160.25,0,0,1,17.38-3.66c5.74-.91,11.39-1.55,16.92-2a260.52,260.52,0,0,1,31.48-.56,227.8,227.8,0,0,1,27.3,2.69c16.54,2.68,29.69,7.05,37.55,12.25,3.91,2.6,6.39,5.47,7.31,7.78a7.55,7.55,0,0,1,.52,1.54,4.94,4.94,0,0,1,.21,1.16C331.89,435.06,331.91,435.32,331.92,435.47Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,280.37a3.19,3.19,0,1,1-3.19-3.2A3.19,3.19,0,0,1,111,280.37Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396.52,
    cy: 282.53,
    r: 3.19,
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.5,400.17a3.2,3.2,0,1,1-3.19-3.19A3.19,3.19,0,0,1,269.5,400.17Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.55,318.13a1.6,1.6,0,1,1-1.6-1.6A1.6,1.6,0,0,1,172.55,318.13Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.06,356.81a1.6,1.6,0,1,1-1.59-1.6A1.6,1.6,0,0,1,371.06,356.81Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245,430.64a1.6,1.6,0,1,1-1.59-1.6A1.6,1.6,0,0,1,245,430.64Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.72,
    cy: 151.17,
    r: 0.8,
    style: {
      fill: "#31859B"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--front-screens--inject-27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M305.65,274c-38.77,10.26-76.14,9.48-116.87,0L184,199.52c42.09,8.19,84.34,7.15,121.63-1.76Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M305.65,274c-38.77,10.26-76.14,9.48-116.87,0L184,199.52c42.09,8.19,84.34,7.15,121.63-1.76Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M299.64,262.65a1,1,0,0,1-.25.12l-.73.31c-.65.26-1.59.68-2.84,1.13a107.27,107.27,0,0,1-10.73,3.36,140.27,140.27,0,0,1-36.78,4.2,214.77,214.77,0,0,1-36.86-3.94c-4.67-.89-8.42-1.71-11-2.31-1.29-.29-2.29-.54-3-.71l-.77-.2c-.17-.05-.26-.08-.25-.09l.27,0,.78.15,3,.61c2.59.54,6.36,1.31,11,2.14a226.31,226.31,0,0,0,36.8,3.79,145,145,0,0,0,36.69-4c4.59-1.16,8.25-2.32,10.75-3.21,1.26-.41,2.21-.8,2.87-1l.75-.26A.75.75,0,0,1,299.64,262.65Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.67,265.68a25.39,25.39,0,0,1-14.92-.5v-26.5a37.48,37.48,0,0,1,14.92,0Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.77,264.11a1.07,1.07,0,0,1,0-.21c0-.15,0-.34,0-.57,0-.54,0-1.28-.07-2.22,0-1.95-.09-4.74-.16-8.23-.1-7-.25-16.87-.42-28.28l.2.24a40.33,40.33,0,0,0-15.45,0l.21-.25v.52c.16,15.66.31,29.81.41,39.91l-.15-.18a35.76,35.76,0,0,0,6.51.8,24.47,24.47,0,0,0,4.91-.41,23,23,0,0,0,3-.79l.75-.26a1.07,1.07,0,0,1,.28-.08l-.24.11-.76.33a21.16,21.16,0,0,1-3,.89,23.47,23.47,0,0,1-4.95.49,34.16,34.16,0,0,1-6.58-.72l-.14,0V265c-.15-10.1-.35-24.24-.57-39.9v-.75l.22,0a40.31,40.31,0,0,1,15.64,0l.2.05v.2c.09,11.46.16,21.35.22,28.41,0,3.47,0,6.24,0,8.19,0,.92,0,1.64,0,2.17,0,.22,0,.41,0,.56S266.78,264.11,266.77,264.11Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.71,261c-4,2.16-9.25,2.45-14.93,2.12V219.34a31.92,31.92,0,0,1,14.93,0Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219,263.52s0-.41-.05-1.13,0-1.79-.06-3.06c0-2.66-.07-6.35-.11-10.74l.14.21a33.36,33.36,0,0,0-14.37-2.39h0l.24-.26c0,5.47,0,10.58,0,14.93l-.13-.2a27.89,27.89,0,0,0,5.76,1.64c1.77.32,3.32.5,4.61.63l3,.25a9.39,9.39,0,0,1,1.06.12,7.9,7.9,0,0,1-1.06,0c-.7,0-1.71,0-3-.13s-2.86-.24-4.64-.53a26.76,26.76,0,0,1-5.88-1.59l-.13-.06v-.15c0-4.35,0-9.46,0-14.93v-.24h.26a33.13,33.13,0,0,1,14.58,2.49l.15.05v.16c0,4.45-.09,8.19-.12,10.89,0,1.25,0,2.25-.06,3A6,6,0,0,1,219,263.52Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226,224.79a15,15,0,0,1-2.92.18c-1.81,0-4.31,0-7.06-.17s-5.23-.42-7-.66a14.77,14.77,0,0,1-2.88-.52,18.33,18.33,0,0,1,2.91.16c1.8.14,4.28.34,7,.5s5.23.26,7,.32A19.44,19.44,0,0,1,226,224.79Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.77,228.05a12.86,12.86,0,0,1-2.56,0c-1.58-.08-3.76-.22-6.17-.4s-4.59-.38-6.16-.55a12.67,12.67,0,0,1-2.53-.38,12.86,12.86,0,0,1,2.56,0c1.59.08,3.76.22,6.17.4s4.58.38,6.15.55A13.07,13.07,0,0,1,223.77,228.05Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.23,232.32s0-.34,0-.93.05-1.5.1-2.58c.1-2.26.25-5.44.44-9.35l.19.21a213.7,213.7,0,0,1-27.63-1.54l.29-.24h0v.4l0,.42-.05.84c0,.56-.06,1.12-.1,1.67-.06,1.11-.12,2.2-.19,3.27-.13,2.15-.25,4.23-.37,6.22l-.21-.26c8,1,14.89,1.4,19.78,1.59l5.73.17,1.5.05.55,0a2.9,2.9,0,0,1-.5,0c-.34,0-.88,0-1.55.05-1.34,0-3.29,0-5.74,0-4.9-.1-11.82-.46-19.83-1.41l-.23,0v-.24c.11-2,.23-4.07.35-6.22.06-1.07.12-2.16.19-3.27l.09-1.67,0-.84,0-.42v-.4h0l.29-.24A236,236,0,0,0,230,219.29h.2v.2c-.27,3.94-.49,7.16-.65,9.44-.08,1.06-.15,1.91-.2,2.53A4.45,4.45,0,0,1,229.23,232.32Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.64,237.93a11.83,11.83,0,0,1-1.93-2.67,9.57,9.57,0,0,1-1.48-2.94,11.83,11.83,0,0,1,1.93,2.67A9.57,9.57,0,0,1,232.64,237.93Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.64,141l12.67,76.68s19.35,36.22,70.75,44.38l-8.29-68.44S98.23,178.9,70.64,141Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.64,141l12.67,76.68s19.35,36.22,70.75,44.38l-8.29-68.44S98.23,178.9,70.64,141Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M147.43,256.58l-.32-.08-1-.27-3.62-1.11c-1.57-.5-3.52-1-5.69-1.9l-3.49-1.33c-1.25-.47-2.56-1-3.89-1.6-2.67-1.22-5.64-2.48-8.66-4.18s-6.24-3.53-9.52-5.62a95.31,95.31,0,0,1-19.1-16.55,56.64,56.64,0,0,1-6.89-9.61l0,0v0l-5.8-37.5c-.7-4.68-1.27-8.43-1.66-11.06l-.42-3-.1-.77a1.09,1.09,0,0,1,0-.27,1,1,0,0,1,.06.26l.15.77.51,3c.43,2.62,1,6.37,1.81,11,1.5,9.42,3.6,22.54,6,37.47l0-.07a57.26,57.26,0,0,0,6.82,9.5,96,96,0,0,0,19,16.49c3.26,2.1,6.37,4.07,9.45,5.64s5.95,3,8.61,4.22c1.32.65,2.63,1.16,3.86,1.63L137,253c2.15.91,4.09,1.45,5.64,2l3.59,1.2.93.32A1.36,1.36,0,0,1,147.43,256.58Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.91,234.32s0,.06-.17.16l-.55.44-2.13,1.66L132,242.77l-.12.1-.1-.14c-2.72-3.75-6.07-8.39-9.87-13.66l.3.05-7.57,5.4-.25.18-.11-.3c-3-8-6.27-17-9.76-26.47l-1.4-3.81.47,0-6.16,12.24-.27.53-.19-.56c-5.37-15.46-9.92-28.6-12.88-37.13l.27,0c-.81,3.42-1.45,6.11-1.89,8-.22.9-.4,1.6-.52,2.1l-.14.54a.62.62,0,0,1-.07.18l0-.19c0-.14.06-.32.1-.54l.45-2.12c.41-1.89,1-4.59,1.76-8l.11-.48.17.47c3,8.51,7.63,21.62,13.08,37.05l-.46,0,6.15-12.24.27-.54.21.56,1.4,3.81c3.47,9.48,6.77,18.47,9.71,26.49l-.36-.11,7.6-5.36.17-.12.13.17L132,242.55l-.23,0,8.17-6.07,2.18-1.6.57-.4Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.14,197.55a4.68,4.68,0,0,1-1.08-.24c-.68-.19-1.67-.49-2.87-.89A94,94,0,0,1,128,192.8a98.07,98.07,0,0,1-8.83-4.53c-1.09-.64-2-1.18-2.56-1.57a4.53,4.53,0,0,1-.89-.65,4.64,4.64,0,0,1,1,.48l2.64,1.42c2.23,1.19,5.34,2.79,8.86,4.38s6.77,2.86,9.14,3.75c1.11.4,2,.75,2.81,1A4,4,0,0,1,141.14,197.55Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.18,200.73a10.35,10.35,0,0,1-2.48-.44,57.41,57.41,0,0,1-5.83-1.74,58.17,58.17,0,0,1-5.61-2.35,10.75,10.75,0,0,1-2.19-1.23,13.68,13.68,0,0,1,2.35.9c1.43.59,3.41,1.39,5.63,2.19s4.26,1.43,5.75,1.88A13.64,13.64,0,0,1,143.18,200.73Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.93,229.09c0,.64-.39,1.15-.87,1.15s-.86-.51-.86-1.15.39-1.15.86-1.15S122.93,228.46,122.93,229.09Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.26,
    cy: 204.85,
    rx: 0.86,
    ry: 1.15,
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.13,179.56c0,.63-.39,1.15-.86,1.15s-.86-.52-.86-1.15.38-1.15.86-1.15S85.13,178.93,85.13,179.56Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406,154.64l-6.35,77.9S381.08,265.85,330,267.12l6.31-78.43S380.88,186.88,406,154.64Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405,150.58c-1.66-5.39-5.7-13.08-15.3-14.68L378.38,240.68s21.31-4.25,21.88-15.93c.05-1,4.31-53.09,5.38-66A21.11,21.11,0,0,0,405,150.58Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M406,154.64l-6.35,77.9S381.08,265.85,330,267.12l6.31-78.43S380.88,186.88,406,154.64Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M404.45,174.5a46.14,46.14,0,0,0-8.13,25.19c-.05,2.59.1,5.26-.89,7.65s-3.55,4.39-6,3.71-3.77-3.8-6.05-5.24a6.75,6.75,0,0,0-6.85.15,11.53,11.53,0,0,0-4.5,5.47c-1.85,4.27-2,9.09-3.34,13.54s-4.72,8.94-9.38,9.14c-1.7.07-3.38-.44-5.08-.39-3.59.11-6.71,2.78-8.38,6s-2.18,6.83-2.66,10.39c0,0,27.22,2.6,57.77-33.48Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.18,221.75c0,1-.48,1.75-1.07,1.75s-1.06-.78-1.06-1.75.47-1.75,1.06-1.75S361.18,220.79,361.18,221.75Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374,189.37c0,1-.48,1.75-1.07,1.75s-1.06-.79-1.06-1.75.47-1.75,1.06-1.75S374,188.4,374,189.37Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.84,178.26a2.4,2.4,0,0,1-.17.44l-.58,1.27c-.54,1.13-1.29,2.73-2.24,4.75l-8.12,16.91-.11.23-.22-.14-19.25-12.18.38-.12c-.25.62-.53,1.29-.8,2L360.3,221.83l-.09.21-.19-.11c-4.8-2.7-8.72-4.87-11.44-6.35-1.37-.74-2.43-1.31-3.16-1.68l-.83-.4-.29-.13a23.22,23.22,0,0,1,4.38,2c2.76,1.42,6.7,3.54,11.53,6.2l-.28.1,12.32-30.49c.27-.67.55-1.34.8-2l.12-.29.26.17,19.22,12.24-.33.09c3.41-6.93,6.27-12.72,8.29-16.82L403,179.9l.64-1.23A2.77,2.77,0,0,1,403.84,178.26Z",
    style: {
      fill: "#31859B"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCore);
export default __webpack_public_path__ + "static/media/core.a3eb9bd723154d3b65f704f778592cc2.svg";
export { ForwardRef as ReactComponent };